const api = "https://py.yorxs.de/live/graphql/";
//const api = "https://pydev.yorxs.de/dev/graphql/";
const diamondListingApi = "diamondData";
const diamondDetailApi = "diamondById";
const pairDiamondListingApi = "pairDiamondData";
const pairDiamondDetailApi = "pairDiamondById";
const diamondSearchByReportApi = "diamondByStockorcert";
const diamondAddToCart = "diamondAddToCart";
const ringAddToCart = "ringAddToCart";
const pendantAddToCart = "pendentAddToCart";
const earringAddToCart = "earringAddToCart";
const productMetafield = "productMetafield";
const storeDefaultCurrencyCode = [ "EUR" ];
const gemstoneListingApi = "gemstoneData";
const gemstoneDetailApi = "gemstoneById";
const gemstoneSearchByReportApi = "gemstoneByStockorcert";
const gemstoneAddToCart = "gemstoneAddToCart";
const gemstoneRingAddToCart = "gemstoneRingAddToCart";
const gemstonePendentAddToCart =  "gemstonePendentAddToCart";
var currencyCode = $("#currencyCode").val();
var currencySymbol = getCurrenySymbol(currencyCode);

/*** Pre Declare Filter Arrays ***/
const cut_array = {"NA": "NA","Poor": "Schlecht","Fair": "Fair", "Good": "Gut", "Very Good": "Sehr Gut", "Excellent": "Exzellent", "Ideal": "Ideal"};
const cut_array_translations = {
    "NA": { de: "NA", fr: "NA", it: "NA", en: "NA" },
    "Poor": { de: "Schlecht", fr: "Pauvre", it: "Povero", en: "Poor" },
    "Fair": { de: "Fair", fr: "Équitable", it: "Fiera", en: "Fair" },
    "Good": { de: "Gut", fr: "Bien", it: "Buono", en: "Good" },
    "Very Good": { de: "Sehr Gut", fr: "Très bien", it: "Molto buono", en: "Very Good" },
    "Excellent": { de: "Exzellent", fr: "Excellent", it: "Eccellente", en: "Excellent" },
    "Ideal": { de: "Ideal", fr: "Idéal", it: "Ideale", en: "Ideal" },
}
const cut_array_values = ["NA","Poor","Fair", "Good", "Very-Good", "Excellent","Ideal"];

const polish_array = {"Poor": "Schlecht","Fair": "Fair", "Good": "Gut", "Very Good": "Sehr Gut", "Excellent": "Exzellent", "Ideal": "Ideal"};
const polish_array_translations = {
    "Poor": { de: "Schlecht", fr: "Pauvre", it: "Povero", en: "Poor" },
    "Fair": { de: "Fair", fr: "Équitable", it: "Fiera", en: "Fair" },
    "Good": { de: "Gut", fr: "Bien", it: "Buono", en: "Good" },
    "Very Good": { de: "Sehr Gut", fr: "Très bien", it: "Molto buono", en: "Very Good" },
    "Excellent": { de: "Exzellent", fr: "Excellent", it: "Eccellente", en: "Excellent" },
    "Ideal": { de: "Ideal", fr: "Idéal", it: "Ideale", en: "Ideal" },
}
const polish_array_values = ["Poor","Fair", "Good", "Very Good", "Excellent","Ideal"];

const symmetry_array = {"Poor": "Schlecht","Fair": "Fair", "Good": "Gut", "Very Good": "Sehr Gut", "Excellent": "Exzellent", "Ideal": "Ideal"};
const symmetry_array_translations = {
    "Poor": { de: "Schlecht", fr: "Pauvre", it: "Povero", en: "Poor" },
    "Fair": { de: "Fair", fr: "Équitable", it: "Fiera", en: "Fair" },
    "Good": { de: "Gut", fr: "Bien", it: "Buono", en: "Good" },
    "Very Good": { de: "Sehr Gut", fr: "Très bien", it: "Molto buono", en: "Very Good" },
    "Excellent": { de: "Exzellent", fr: "Excellent", it: "Eccellente", en: "Excellent" },
    "Ideal": { de: "Ideal", fr: "Idéal", it: "Ideale", en: "Ideal" },
}
const symmetry_array_values = ["Poor","Fair", "Good", "Very Good", "Excellent","Ideal"];

const fluorescence_array = {"Very Strong": "Sehr Stark", "Strong": "Stark", "Medium": "Mittelmäßig", "Slight": "Leicht", "Faint": "Schwach", "Very Slight": "Sehr leicht", "None": "Keine"};
const fluorescence_array_translations = {
    "Very Strong": { de: "Sehr Stark", fr: "Très fort", it: "Molto forte", en: "Very Strong" },
    "Strong": { de: "Stark", fr: "Fort", it: "Forte", en: "Strong" },
    "Medium": { de: "Mittelmäßig", fr: "Médiocre", it: "Mediocre", en: "Medium" },    
    "Slight": { de: "Leicht", fr: "Léger", it: "Lieve", en: "Slight" },
    "Faint": { de: "Schwach", fr: "Faible", it: "Debole", en: "Faint" },
    "Very Slight": { de: "Sehr leicht", fr: "Très léger", it: "Molto lieve", en: "Very Slight" },
    "None": { de: "Keine", fr: "Non", it: "Nessuno", en: "None" },
}
const fluorescence_array_values = ["Very Strong", "Strong", "Medium", "Slight", "Faint", "Very Slight", "None"];

const clarity_array = {"Salt and Pepper": "Salz und Pfeffer","SI2": "SI2","SI1": "SI1","VS2": "VS2","VS1": "VS1","VVS2": "VVS2","VVS1": "VVS1","IF": "IF","FL": "FL"};
const clarity_array_values = ["Salt and Pepper","SI2","SI1","VS2","VS1","VVS2","VVS1","IF","FL"];
const clarity_array_translations = {
    "Salt and Pepper": { de: "Salz und Pfeffer", fr: "Sel et Poivre", it: "Sale e Pepe", en: "Salt and Pepper" },
    "SI2": { de: "SI2", fr: "SI2", it: "SI2", en: "SI2" },
    "SI1": { de: "SI1", fr: "SI1", it: "SI1", en: "SI1" },    
    "VS2": { de: "VS2", fr: "VS2", it: "VS2", en: "VS2" },
    "VS1": { de: "VS1", fr: "VS1", it: "VS1", en: "VS1" },
    "VVS2": { de: "VVS2", fr: "VVS2", it: "VVS2", en: "VVS2" },
    "VVS1": { de: "VVS1", fr: "VVS1", it: "VVS1", en: "VVS1" },
    "IF": { de: "IF", fr: "IF", it: "IF", en: "IF" },
    "FL": { de: "FL", fr: "FL", it: "FL", en: "FL" }
}

const treatment_array = {"None": "None","Heating and Pressure": "Heating and Pressure","Heating": "Heating","Oiling": "Oiling"};
const treatment_array_values = ["None","Heating and Pressure","Heating","Oiling"];

const color_array = {"K-Z": "K-Z","J": "J","I": "I","H": "H","G": "G","F": "F","E": "E","D": "D"};
const color_array_values = ["K-Z","J","I","H","G","F","E","D"];

const intensity_array = {"Faint":"Faint","Very Light":"Very Light","Light":"Light","Fancy Light":"Fancy Light","Fancy":"Fancy","Fancy Dark":"Fancy Dark","Intense":"Intense","Fancy Intense":"Intensiv","Vivid":"Vivid","Fancy Vivid":"Intensiv leuchtend","Deep":"Deep","Fancy Deep":"Tief"};
const intensity_array_values = ["Faint","Very Light","Light","Fancy Light","Fancy","Fancy Dark","Intense","Fancy Intense","Vivid","Fancy Vivid","Deep","Fancy Deep"];

const gemClarity_array = {"EC": "EC","MI": "MI","SI": "SI","VI1": "VI1","VI": "VI"};
const gemClarity_array_values = ["EC","MI","SI","VI1","VI"];

const intensity_array_gem = {"Very Light":"Sehr hell","Light":"Hell","Medium Intense":"Mittel","Intense":"Intensiv","Vivid":"Leuchtend","Deep":"Tief","Dark":"Dunkel"};
const intensity_array_values_gem = ["Very Light","Light","Medium Intense","Intense","Vivid","Deep","Dark"];



/*** End ***/

/*** Store Language Code ***/
const store_lang = window.Shopify.locale;
/*** End ***/


/*** get currency symbol start ***/
function getCurrenySymbol(CurrenyCode) {
	var currency_symbol;
	switch (CurrenyCode) {
        case 'EUR':
			currency_symbol = '€';
			break;
		case 'USD':
			currency_symbol = '$';
			break;
        case 'GBP':
			currency_symbol = '£';
			break;
		default:
			currency_symbol = '€';
	}

	return currency_symbol;
}
/*** get currency symbol end ***/

/*** addCommas in price start ***/
function addCommas(price) {
	price += '';
	x = price.split('.');
	x1 = x[0];
	x2 = x.length > 1 ? '.' + x[1] : '';
	var rgx = /(\d+)(\d{3})/;
	while (rgx.test(x1)) {
		x1 = x1.replace(rgx, '$1' + ',' + '$2');
	}
	return x1 + x2;
}
/*** addCommas in price end ***/


function setSelectedFilter(filter_value, func, hasSelectedClass, input_value = '') {  
  
  if(filter_value === 'Edelsteine') {
        filter_value = 'Gemstone'
    }

	if (input_value == 'price') {
		$('.selected_filter_container').find('li[data-input="price"]').remove();
	}else if (input_value == 'carat') {     
		$('.selected_filter_container').find('li[data-input="carat"]').remove();
	}else if (input_value == 'depth') {
		$('.selected_filter_container').find('li[data-input="depth"]').remove();
	}else if (input_value == 'table') {
		$('.selected_filter_container').find('li[data-input="table"]').remove();
    }else if (input_value == 'cut') {
		$('.selected_filter_container').find('li[data-input="cut"]').remove();
	}else if (input_value == 'polish') {
		$('.selected_filter_container').find('li[data-input="polish"]').remove();
	}else if (input_value == 'symmetry') {
		$('.selected_filter_container').find('li[data-input="symmetry"]').remove();
	}else if (input_value == 'fluorescence') {
		$('.selected_filter_container').find('li[data-input="fluorescence"]').remove();
	}else if (input_value == 'clarity') {
		$('.selected_filter_container').find('li[data-input="clarity"]').remove();
	}else if (input_value == 'treatment') {
		$('.selected_filter_container').find('li[data-input="treatment"]').remove();
    }else if (input_value == 'colour' || input_value == 'color') {
		$('.selected_filter_container').find('li[data-input="color"]').remove();
	}else if (input_value == 'intensity') {
		$('.selected_filter_container').find('li[data-input="intensity"]').remove();
	}else if (input_value == 'gemClarity') {
		$('.selected_filter_container').find('li[data-input="gemClarity"]').remove();
	}else if (input_value == 'gemIntensity') {
		$('.selected_filter_container').find('li[data-input="gemIntensity"]').remove();
	}   

	var value = filter_value.split(':');
   
    var filterDiveId = value[0];
    if(value[0].indexOf(' ') >= 0){
      filterDiveId = value[0].replace(" ","_") 
    }
 
	if (hasSelectedClass) {      
		var html = '';
        var filter_lable = value[1].trim();

        if (input_value === 'cut') {
          const cutParts = filter_lable.split(' - ');
          filter_lable = cutParts.map(part => {
            const translation = cut_array_translations[part];
            return translation ? (translation[lang.toLowerCase()] || part) : part;
          }).join(' - ');
        } else if (input_value === 'polish') {
          const polishParts = filter_lable.split(' - ');
          filter_lable = polishParts.map(part => {
            const translation = polish_array_translations[part];
            return translation ? (translation[lang.toLowerCase()] || part) : part;
          }).join(' - ');
        } else if (input_value === 'symmetry') {
          const symmetryParts = filter_lable.split(' - ');
          filter_lable = symmetryParts.map(part => {
            const translation = symmetry_array_translations[part];
            return translation ? (translation[lang.toLowerCase()] || part) : part;
          }).join(' - ');
        }  else if (input_value === 'fluorescence') {
          const fluorescenceParts = filter_lable.split(' - ');
          filter_lable = fluorescenceParts.map(part => {
            const translation = fluorescence_array_translations[part];
            return translation ? (translation[lang.toLowerCase()] || part) : part;
          }).join(' - ');
        } else if (input_value === 'clarity') {
          const clarityParts = filter_lable.split(' - ');
          filter_lable = clarityParts.map(part => {
            const translation = clarity_array_translations[part];
            return translation ? (translation[lang.toLowerCase()] || part) : part;
          }).join(' - ');
        } else if(input_value === 'price'){
          
            //var filter_lable = "£186.00 - £1,500,000.00"; // Example
            var currentCurrency = Shopify.currency.active || window.ShopifyCurrency.shopCurrency;                         
            var exchangeRate = parseFloat(Shopify.currency.rate || 1).toFixed(2);
            
            // List of European currencies that use , as decimal and . as thousands
            var europeanCurrencies = ['DKK', 'NOK', 'SEK', 'HUF', 'CZK', 'PLN', 'EUR'];
            
            function isEuropeanCurrency(currency) {
              return europeanCurrencies.includes(currency);
            }
            
            // Step 1: Remove ,00 or .00 from display (not for parsing)
            function removeTrailingZerosByCurrency(priceStr, currency) {
              return isEuropeanCurrency(currency)
                ? priceStr.replace(/,00(?=\D|$)/g, '')
                : priceStr.replace(/\.00(?=\D|$)/g, '');
            }
            
            // Step 2: Parse number safely
            function parsePriceByCurrency(priceStr, currency) {
              const cleaned = priceStr.replace(/[^\d.,]/g, '');
            
              if (isEuropeanCurrency(currency)) {
                // Convert '1.500.000,00' → '1500000.00'
                return parseFloat(cleaned.replace(/\./g, '').replace(',', '.'));
              } else {
                // Convert '1,500,000.00' → '1500000.00'
                return parseFloat(cleaned.replace(/,/g, ''));
              }
            }
            
            // Step 3: Format final money string
            function formatMoneyValue(floatValue) {
              const cents = Math.round(floatValue * 100);
              return Shopify.formatMoney(cents, theme.moneyFormat);
            }
            
            // Process logic
            const range = filter_lable.split(' - ');
             
            // Clean display first
            const cleanedRange = range.map(price => removeTrailingZerosByCurrency(price, currentCurrency));
          
            // Parse to float
            let value1 = Math.round(parsePriceByCurrency(cleanedRange[0], currentCurrency) * exchangeRate);
            let value2 = Math.round(parsePriceByCurrency(cleanedRange[1], currentCurrency) * exchangeRate);
            console.log("dia_value1",value1);
            console.log("dia_value2",value2);

          // ✅ Step 2: Dynamically check localStorage for any setting price
          const currentBuilder = document.getElementById('current_builder')?.value;
          if (
          currentBuilder !== 'tps_loose-diamond-listing' &&
          currentBuilder !== 'tps_loose-diamond-color-listing' &&
          currentBuilder !== 'tps_lab-diamond-listing' &&
          currentBuilder !== 'tps_lab-diamond-color-listing'
        ){
            const keyMappings = {
              'ring_step1': 'ring_setting',
              'pendant_step1': 'pendant_setting',
              'earring_step1': 'earring_setting',
              'gemstone_ring_step1': 'gemstonering_setting',
              'gem_pendant_step1': 'gem_pendant_setting'
            };
            
            Object.entries(keyMappings).forEach(([stepKey, settingKey]) => {
              if (localStorage.getItem(stepKey) === 'setting') {
                const settingInfoRaw = localStorage.getItem(settingKey);
                if (settingInfoRaw) {
                  try {
                    const settingInfo = JSON.parse(settingInfoRaw);
                    const settingPrice = parseInt(settingInfo[0]?.setting_price || 0) / 100;
                    value1 += settingPrice;
                    value2 += settingPrice;
                  } catch (e) {
                    console.warn(`Invalid setting data in localStorage for ${settingKey}`);
                  }
                }
              }
            });
          }
            // Format
            let dia_value1 = formatMoneyValue(value1);
            let dia_value2 = formatMoneyValue(value2);
            
            // Remove trailing decimal in display
            dia_value1 = removeTrailingZerosByCurrency(dia_value1, currentCurrency);
            dia_value2 = removeTrailingZerosByCurrency(dia_value2, currentCurrency);
            
            // Final label
            var formattedRange = `${dia_value1} - ${dia_value2}`;          
            filter_lable = formattedRange;
            

        }

        if(input_value != 'price' && input_value != 'carat' && input_value != 'depth' && input_value != 'table' && input_value != 'cut' && input_value != 'polish' && input_value != 'symmetry' && input_value != 'fluorescence' && input_value != 'clarity' && input_value != 'gemClarity' && input_value != 'treatment' && input_value != 'color' && input_value != 'intensity' && input_value != 'gemIntensity') {
          filter_lable = filter_lable.replace(/\-/g, ' ');
        }        
		html += '<li onclick="' + func + '" data-input="' + input_value + '" data-filter_value="' + filter_value + '"><div class="tps_filter_values">' + filter_lable + '<span class="tps-pendantbuilder-remove-option"></span></div></li>';
        
		if ($('#' + filterDiveId + '_container').length > 0) {
			$('#' + filterDiveId + '_container').append(html);
		} else {
		  var labelText = value[0]; 
          var langKey = lang.toLowerCase();

          var filterTranslationMap = {
            Gemstone: { de: "Edelsteine", fr: "Pierre Précieuse", it: "Pietra Preziosa", en: "Gemstone" },
            Cut: { de: "Schliffgrad", fr: "Qualité De Broyage", it: "Sliffgrado", en: "Cut" },
            Shape: { de: "Form", fr: "Formulaire", it: "Forma", en: "Shape" },
            Colour: { de: "Farbe", fr: "Couleur", it: "Colore", en: "Colour" },
            Clarity: { de: "Reinheit", fr: "Purité", it: "Purezza", en: "Clarity" },
            Lab: { de: "Zertifikat", fr: "Certificat", it: "Certificato", en: "Lab" },
            Intensity: { de: "Intensität", fr: "Intensité", it: "Intensità", en: "Intensity" },
            Carat: { de: "Karat", fr: "Carat", it:"Carato", en:"Carat" },
            Price: { de: "Preis", fr: "Prix", it:"Prezzo", en:"Price" },
            Treatment: { de: "Behandlung", fr: "Treatment", it:"Trattamento", en:"Treatment" },
            Polish: { de: "Politur", fr: "Polonais", it:"Politica", en:"Polish" },
            Symmetry: { de: "Symmetrie", fr: "Symétrie", it:"Simmetria", en:"Symmetry" },
            Fluorescence: { de: "Fluoreszenz", fr: "Fluorescence", it:"Fluorescenza", en:"Fluorescence" },
            Table: { de: "Tabel", fr: "Conseil", it:"Lavagna", en:"Table" },
            Depth: { de: "Tiefe", fr: "Profondeur", it:"Profondità", en:"Depth" },
            Overtone: { de: "Overtone", fr: "Harmonique", it:"Sovratono", en:"Overtone" }
        };

          if (filterTranslationMap[labelText]) {
            labelText = filterTranslationMap[labelText][langKey] || filterTranslationMap[labelText]['en'];
            labelText = labelText;
          }
          
          var elecontainer = '<ul id="' + filterDiveId + '_container"><span class="tps_applied_filter_lable ss">' + labelText.replace(/\-/g, " ") + ':</span></ul>';
          $('.selected_filter_container').append(elecontainer);
          $('#' + filterDiveId + '_container').append(html);
		} 
	} else {       
		$('.selected_filter_container').find('li[data-filter_value="' + filter_value + '"]').remove();
       

		if ($('input[value="' + input_value + '"]').length > 0) {
			$('input[value="' + input_value + '"]').prop('checked', false);
		}
		if ($('#' + filterDiveId + '_container li').length == 0) {
			$('#' + filterDiveId + '_container').remove();
		}
	}
	if ($('.selected_filter_container li').length > 0) {
        $('.tps_selected_filter_wrapper').show();
    } else {
        $('.tps_selected_filter_wrapper').hide();
    }
}

/*** set selected filters for session filters after reloading page end ***/

/*** tps config function to get urls start ***/

if(store_lang == 'de'){
  var tps_config = {
	"urls": {
        "pendantbuilder_loose_gemstone_detail": "/pages/pendantbuilder-edelsteine-einzelheiten",
        "pendantbuilder_loose_gemstone": "/pages/pendantbuilder-naturlicher-edelsteine",
        "gemstone_pendant_builder_final_page":"/pages/endgultig-edelsteineanhanger",
        "gemstone_pendant_builder_listing":"/collections/anhanger-mit-farbedelstein",
        "gemstonering_builder_final_page": "/pages/endgultig-edelsteinering",
        "gemstonering_builder_listing": "/collections/edelsteineringe",	
        "ringbuilder_loose_gemstone_detail": "/pages/ringbuilder-edelsteine-einzelheiten",
        "ringbuilder_loose_gemstone": "/pages/ringbuilder-naturlicher-edelsteine",
        "earring_builder_listing": "/collections/diamant-ohrstecker",
        "earringbuilder_loose_diamond": "/pages/earringbuilder-naturlicher-weisser-diamant",
        "earringbuilder_loose_fancy_diamond": "/pages/earringbuilder-naturlicher-farbiger-diamant",
        "earringbuilder_lab_diamond": "/pages/earringbuilder-labor-weisser-diamant",
        "earringbuilder_lab_fancy_diamond": "/pages/earringbuilder-laborfarbiger-diamant",
		"earringbuilder_loose_diamond_detail": "/pages/earringbuilder-diamant-einzelheiten",
        "earring_builder_final_page": "/pages/letzter-ohrring",
		"pendant_builder_listing": "/collections/diamant-anhanger",		
		"pendantbuilder_loose_diamond": "/pages/pendantbuilder-naturlicher-weisser-diamant",
        "pendantbuilder_loose_fancy_diamond": "/pages/pendantbuilder-naturlicher-farbiger-diamant",
        "pendantbuilder_lab_diamond": "/pages/pendantbuilder-labor-weisser-diamant",
        "pendantbuilder_lab_fancy_diamond": "/pages/pendantbuilder-laborfarbiger-diamant",
		"pendantbuilder_loose_diamond_detail": "/pages/pendantbuilder-diamant-einzelheiten",
        "pendant_builder_final_page": "/pages/abschlusspendel",
        "ring_builder_listing": "/collections/verlobungsringe",	
        "ring_builder_diaListing": "/collections/diamantringe",	
		"ringbuilder_loose_diamond": "/pages/ringbuilder-naturlicher-weisser-diamant",
        "ringbuilder_loose_fancy_diamond": "/pages/ringbuilder-naturlicher-farbiger-diamant",
        "ringbuilder_lab_diamond": "/pages/ringbuilder-labor-weisser-diamant",
        "ringbuilder_lab_fancy_diamond": "/pages/ringbuilder-laborfarbiger-diamant",
		"ringbuilder_loose_diamond_detail": "/pages/ringbuilder-diamant-einzelheiten",
        "ring_builder_final_page": "/pages/endgultig-ring",
        "lab_color_diamond": "/pages/laborfarbiger-diamant",
        "lab_diamond": "/pages/labor-weisser-diamant",
        "loose_color_diamond": "/pages/naturlicher-farbiger-diamant",
        "loose_diamond": "/pages/diamanten-kaufen",
        "loose_diamond_detail": "/pages/diamant-einzelheiten",
        "loose_gemstone":"/pages/edelsteine",
        "loose_gemstone_detail":"/pages/gemstone-details",
        "loose_gemstone_alex":"/pages/edelstein-alexandrit",
        "loose_gemstone_aqu":"/pages/edelstein-aquamarin",
        "loose_gemstone_gra":"/pages/edelstein-granat",
        "loose_gemstone_mor":"/pages/edelstein-morganit",
        "loose_gemstone_per":"/pages/edelstein-peridot",
        "loose_gemstone_rub":"/pages/edelstein-rubin",
        "loose_gemstone_sap":"/pages/edelstein-saphir",
        "loose_gemstone_sma":"/pages/edelstein-smaragd",
        "loose_gemstone_tan":"/pages/edelstein-tanzanit",
        "loose_gemstone_tur":"/pages/edelstein-turmalin",
        "loose_gemstone_zir":"/pages/edelstein-zirkon"	}
  }
}else if(store_lang == 'fr'){
  var tps_config = {
	"urls": {
        "pendantbuilder_loose_gemstone_detail": "/fr/pages/pendantbuilder-edelsteine-einzelheiten",
        "pendantbuilder_loose_gemstone": "/fr/pages/pendantbuilder-naturlicher-edelsteine",
        "gemstone_pendant_builder_final_page":"/fr/pages/endgultig-edelsteineanhanger",
        "gemstone_pendant_builder_listing":"/fr/collections/anhanger-mit-farbedelstein",
        "gemstonering_builder_final_page": "/fr/pages/endgultig-edelsteinering",
        "gemstonering_builder_listing": "/fr/collections/edelsteineringe",	
        "ringbuilder_loose_gemstone_detail": "/fr/pages/ringbuilder-edelsteine-einzelheiten",
        "ringbuilder_loose_gemstone": "/fr/pages/ringbuilder-naturlicher-edelsteine",
        "earring_builder_listing": "/fr/collections/diamant-ohrstecker",
        "earringbuilder_loose_diamond": "/fr/pages/earringbuilder-naturlicher-weisser-diamant",
        "earringbuilder_loose_fancy_diamond": "/fr/pages/earringbuilder-naturlicher-farbiger-diamant",
        "earringbuilder_lab_diamond": "/fr/pages/earringbuilder-labor-weisser-diamant",
        "earringbuilder_lab_fancy_diamond": "/fr/pages/earringbuilder-laborfarbiger-diamant",
		"earringbuilder_loose_diamond_detail": "/fr/pages/earringbuilder-diamant-einzelheiten",
        "earring_builder_final_page": "/fr/pages/letzter-ohrring",
		"pendant_builder_listing": "/fr/collections/diamant-anhanger",		
		"pendantbuilder_loose_diamond": "/fr/pages/pendantbuilder-naturlicher-weisser-diamant",
        "pendantbuilder_loose_fancy_diamond": "/fr/pages/pendantbuilder-naturlicher-farbiger-diamant",
        "pendantbuilder_lab_diamond": "/fr/pages/pendantbuilder-labor-weisser-diamant",
        "pendantbuilder_lab_fancy_diamond": "/fr/pages/pendantbuilder-laborfarbiger-diamant",
		"pendantbuilder_loose_diamond_detail": "/fr/pages/pendantbuilder-diamant-einzelheiten",
        "pendant_builder_final_page": "/fr/pages/pendule-final",
        "ring_builder_listing": "/fr/collections/verlobungsringe",	
        "ring_builder_diaListing": "/fr/collections/diamantringe",	
		"ringbuilder_loose_diamond": "/fr/pages/ringbuilder-naturlicher-weisser-diamant",
        "ringbuilder_loose_fancy_diamond": "/fr/pages/ringbuilder-naturlicher-farbiger-diamant",
        "ringbuilder_lab_diamond": "/fr/pages/ringbuilder-labor-weisser-diamant",
        "ringbuilder_lab_fancy_diamond": "/fr/pages/ringbuilder-laborfarbiger-diamant",
		"ringbuilder_loose_diamond_detail": "/fr/pages/ringbuilder-diamant-einzelheiten",
        "ring_builder_final_page": "/fr/pages/endgultig-ring",
        "lab_color_diamond": "/fr/pages/laborfarbiger-diamant",
        "lab_diamond": "/fr/pages/labor-weisser-diamant",
        "loose_color_diamond": "/fr/pages/naturlicher-farbiger-diamant",
        "loose_diamond": "/fr/pages/diamanten-kaufen",
        "loose_diamond_detail": "/fr/pages/details",
        "loose_gemstone":"/fr/pages/pierres-precieuses",
        "loose_gemstone_detail":"/fr/pages/gemstone-details",
        "loose_gemstone_alex":"/fr/pages/pierre-precieuse-alexandrite",
        "loose_gemstone_aqu":"/fr/pages/pierre-precieuse-aigue-marine",
        "loose_gemstone_gra":"/fr/pages/pierre-precieuse-grenat",
        "loose_gemstone_mor":"/fr/pages/pierre-precieuse-morganite",
        "loose_gemstone_per":"/fr/pages/pierre-precieuse-peridot",
        "loose_gemstone_rub":"/fr/pages/pierre-precieuse-rubis",
        "loose_gemstone_sap":"/fr/pages/pierre-precieuse-saphir",
        "loose_gemstone_sma":"/fr/pages/pierre-precieuse-emeraude",
        "loose_gemstone_tan":"/fr/pages/pierre-precieuse-tanzanite",
        "loose_gemstone_tur":"/fr/pages/pierre-precieuse-tourmaline",
        "loose_gemstone_zir":"/fr/pages/pierre-precieuse-zircon"
	}
  }
}else if(store_lang == 'it'){
  var tps_config = {
    "urls": {
        "pendantbuilder_loose_gemstone_detail": "/it/pages/dettagli-delle-pietre-preziose-del-pendente",
        "pendantbuilder_loose_gemstone": "/it/pages/ciondolobuilder-pietre-naturali",
        "gemstone_pendant_builder_final_page":"/it/pages/pendente-finale-della-pietra-preziosa",
        "gemstone_pendant_builder_listing":"/it/collections/pendente-con-pietra-preziosa-colorata",
        "gemstonering_builder_final_page": "/it/pages/anello-finale-con-pietre-preziose",
        "gemstonering_builder_listing": "/it/collections/anelli-di-pietre-preziose", 
        "ringbuilder_loose_gemstone_detail": "/it/pages/dettagli-delle-gemme-del-ringbuilder",
        "ringbuilder_loose_gemstone": "/it/pages/ringbuilder-pietre-naturali",
        "earring_builder_listing": "/it/collections/diamant-ohrstecker",
        "earringbuilder_loose_diamond": "/it/pages/orecchino-builder-diamante-bianco-naturale",
        "earringbuilder_loose_fancy_diamond": "/it/pages/orecchino-builder-diamante-colore-naturale",
        "earringbuilder_lab_diamond": "/it/pages/orecchinobuilder-laboratorio-diamante-bianco",
        "earringbuilder_lab_fancy_diamond": "/it/pages/orecchino-builder-lab-diamante-colorato",
        "earringbuilder_loose_diamond_detail": "/it/pages/dettagli-del-diamante-del-costruttore-dell-orecchino",
        "earring_builder_final_page": "/it/pages/ultimo-orecchino",
        "pendant_builder_listing": "/it/collections/diamant-anhanger",     
        "pendantbuilder_loose_diamond": "/it/pages/ciondolobuilder-diamante-bianco-naturale",
        "pendantbuilder_loose_fancy_diamond": "/it/pages/ciondolobuilder-diamante-colore-naturale",
        "pendantbuilder_lab_diamond": "/it/pages/ciondolobuilder-laboratory-bianco-diamante",
        "pendantbuilder_lab_fancy_diamond": "/it/pages/ciondolobuilder-laboratorio-diamante-colorato",
        "pendantbuilder_loose_diamond_detail": "/it/pages/dettagli-di-diamanti-ciondolobuilder",
        "pendant_builder_final_page": "/it/pages/pendolo-finale",
        "ring_builder_listing": "/it/collections/verlobungsringe", 
        "ring_builder_diaListing": "/it/collections/diamantringe", 
        "ringbuilder_loose_diamond": "/it/pages/costruttore-di-anelli-diamante-bianco-naturale",
        "ringbuilder_loose_fancy_diamond": "/it/pages/costruttore-di-anelli-con-diamante-di-colore-naturale",
        "ringbuilder_lab_diamond": "/it/pages/ringbuilder-lab-diamante-bianco",
        "ringbuilder_lab_fancy_diamond": "/it/pages/ringbuilder-lab-diamante-colorato",
        "ringbuilder_loose_diamond_detail": "/it/pages/dettagli-del-diamante-del-ringbuilder",
        "ring_builder_final_page": "/it/pages/anello-finale",
        "lab_color_diamond": "/it/pages/diamante-colorato-in-laboratorio",
        "lab_diamond": "/it/pages/diamante-bianco-da-laboratorio",
        "loose_color_diamond": "/it/pages/diamante-di-colore-naturale",
        "loose_diamond": "/it/pages/acquistare-diamanti",
        "loose_diamond_detail": "/it/pages/dettagli",
        "loose_gemstone":"/it/pages/pietre-preziose",
        "loose_gemstone_detail":"/it/pages/dettagli-di-pietre-preziose",
        "loose_gemstone_alex":"/it/pages/pietre-preziose-alessandrite",
        "loose_gemstone_aqu":"/it/pages/pietre-preziose-acquamarina",
        "loose_gemstone_gra":"/it/pages/pietre-preziose-granato",
        "loose_gemstone_mor":"/it/pages/pietre-preziose-morganite",
        "loose_gemstone_per":"/it/pages/pietre-preziose-peridoto",
        "loose_gemstone_rub":"/it/pages/pietre-preziose-rubino",
        "loose_gemstone_sap":"/it/pages/pietre-preziose-zaffiro",
        "loose_gemstone_sma":"/it/pages/pietre-preziose-smeraldo",
        "loose_gemstone_tan":"/it/pages/pietre-preziose-tanzanite",
        "loose_gemstone_tur":"/it/pages/pietre-preziose-tormalina",
        "loose_gemstone_zir":"/it/pages/pietre-preziose-zirconio"
    }
  }
}else{
  var tps_config = {
	"urls": {
        "pendantbuilder_loose_gemstone_detail": "/en/pages/pendant-builder-gemstone-details",
        "pendantbuilder_loose_gemstone": "/en/pages/pendantbuilder-loose-gemstone",
        "gemstone_pendant_builder_final_page":"/en/pages/final-gemstonependant",
        "gemstone_pendant_builder_listing":"/en/collections/pendants-with-gemstones",
        "gemstonering_builder_final_page": "/en/pages/final-gemstonering",
        "gemstonering_builder_listing": "/en/collections/gemstonering",	
        "ringbuilder_loose_gemstone_detail": "/en/pages/ring-builder-gemstone-details",
        "ringbuilder_loose_gemstone": "/en/pages/ringbuilder-natural-gemstone",
        "earring_builder_listing": "/en/collections/diamond-stud-earrings",
        "earringbuilder_loose_diamond": "/en/pages/earringbuilder-natural-white-diamond",
        "earringbuilder_loose_fancy_diamond": "/en/pages/earringbuilder-natural-colored-diamond",
        "earringbuilder_lab_diamond": "/en/pages/earringbuilder-lab-white-diamond",
        "earringbuilder_lab_fancy_diamond": "/en/pages/earringbuilder-lab-colored-diamond",
		"earringbuilder_loose_diamond_detail": "/en/pages/earring-builder-diamond-details",
        "earring_builder_final_page": "/en/pages/final-earring",
		"pendant_builder_listing": "/en/collections/diamond-pendants",		
		"pendantbuilder_loose_diamond": "/en/pages/pendantbuilder-natural-white-diamond",
        "pendantbuilder_loose_fancy_diamond": "/en/pages/pendantbuilder-natural-colored-diamond",
        "pendantbuilder_lab_diamond": "/en/pages/pendantbuilder-lab-white-diamond",
        "pendantbuilder_lab_fancy_diamond": "/en/pages/pendantbuilder-lab-colored-diamond",
		"pendantbuilder_loose_diamond_detail": "/en/pages/pendant-builder-diamond-details",
        "pendant_builder_final_page": "/en/pages/final-pendant",
        "ring_builder_listing": "/en/collections/engagement-rings",	
        "ring_builder_diaListing": "/en/collections/diamantringe",	
		"ringbuilder_loose_diamond": "/en/pages/ringbuilder-natural-white-diamond",
        "ringbuilder_loose_fancy_diamond": "/en/pages/ringbuilder-natural-colored-diamond",
        "ringbuilder_lab_diamond": "/en/pages/ringbuilder-lab-white-diamond",
        "ringbuilder_lab_fancy_diamond": "/en/pages/ringbuilder-lab-colored-diamond",
		"ringbuilder_loose_diamond_detail": "/en/pages/ring-builder-diamond-details",
        "ring_builder_final_page": "/en/pages/endgultig-ring",
        "lab_color_diamond": "/en/pages/lab-colored-diamond",
        "lab_diamond": "/en/pages/lab-white-diamond",
        "loose_color_diamond": "/en/pages/natural-colored-diamond",        
        "loose_diamond": "/en/pages/diamond-search",
        "loose_diamond_detail": "/en/pages/diamond-details",
        "loose_gemstone":"/en/pages/gemstones",
        "loose_gemstone_detail":"/en/pages/gemstone-details",
        "loose_gemstone_alex":"/en/pages/gemstone-alexandrite",
        "loose_gemstone_aqu":"/en/pages/gemstone-aquamarine",
        "loose_gemstone_gra":"/en/pages/gemstone-garnet",
        "loose_gemstone_mor":"/en/pages/gemstone-morganite",
        "loose_gemstone_per":"/en/pages/gemstone-peridot",
        "loose_gemstone_rub":"/en/pages/gemstone-ruby",
        "loose_gemstone_sap":"/en/pages/gemstone-sapphire",
        "loose_gemstone_sma":"/en/pages/gemstone-emerald",
        "loose_gemstone_tan":"/en/pages/gemstone-tanzanite",
        "loose_gemstone_tur":"/en/pages/gemstone-tourmaline",
        "loose_gemstone_zir":"/en/pages/gemstone-zircon"
	}

  }
}



/*** tps confif function to get urls end ***/

/*** Diamond Carat Filter Start ***/
var minDiamondCarat = parseFloat($('#diamondMincarat').val());
var maxDiamondCarat = parseFloat($('#diamondMaxcarat').val());

var carat = [];
for (i = minDiamondCarat; i < 1; i = i + 0.01) {
	var dec = i.toFixed(2);
	carat.push(dec);
}
for (i = 1; i < 1.5; i = i + 0.30) {
	var dec = i.toFixed(2);
	carat.push(dec);
}
for (i = 1; i < 2; i = i + 0.60) {
	var dec = i.toFixed(2);
	carat.push(dec);
}
for (i = 2; i < maxDiamondCarat; i = i + 0.65) {
	var dec = i.toFixed(2);
	carat.push(dec);
}
carat.push(maxDiamondCarat);

Shopify.money_format = '&pound;{{amount}}';
var currency_symbol = currencySymbol;

function getClosestNum(num, ar) {
	var i = 0,
		closest, closestDiff, currentDiff;
	if (ar.length) {
		closest = ar[0];
		for (i; i < ar.length; i++) {
			closestDiff = Math.abs(num - closest);
			currentDiff = Math.abs(num - ar[i]);
			if (currentDiff < closestDiff) {
				closest = ar[i];
			}
			closestDiff = null;
			currentDiff = null;
		}
      
		//returns first element that is closest to number
		return closest;
	}
	//no length
	return false;
}

function get_index(value, array) {
	var pos = 0
	for (i = 0; i < array.length; i++) {
		if (array[i] == value) {
			pos = i;
			break;
		}
	}
	return pos;
}


if(store_lang == 'de'){
  var caratFilterUnit = 'Karat';
}else{
  var caratFilterUnit = 'Carat';
}  
function carat_slider_render(start, end, option) { 
    jQuery('.tps-diamondlist-result-list-view-loader').show();
    jQuery('.tps-diamondlist-result-grid-view-loader').show();
  
    var start2 = getClosestNum(start, carat);
	var end2 = getClosestNum(end, carat);   
	var start1 = get_index(start2, carat);
	var start11 = get_index(start, carat);
	var end11 = get_index(end, carat);
	var end1 = get_index(end2, carat);
      
	var settingSelected = jQuery("#setting").val();

    var min_carat = parseFloat($("#diamondMincarat").val()).toFixed(2);
    var max_carat = parseFloat($("#diamondMaxcarat").val()).toFixed(2);    
    
    var ring_setting = localStorage.getItem("ring_setting");  
    var ringbuilder_loose_diamond_en = window.location.href.indexOf('ringbuilder-natural-white-diamond');
    var ringbuilder_loose_diamond_de = window.location.href.indexOf('ringbuilder-naturlicher-weisser-diamant');
    var ringbuilder_loose_color_diamond_en = window.location.href.indexOf('ringbuilder-natural-colored-diamond');
    var ringbuilder_loose_color_diamond_de = window.location.href.indexOf('ringbuilder-naturlicher-farbiger-diamant');
    var ringbuilder_lab_diamond_en = window.location.href.indexOf('ringbuilder-lab-white-diamond');
    var ringbuilder_lab_diamond_de = window.location.href.indexOf('ringbuilder-labor-weisser-diamant');
    var ringbuilder_lab_color_diamond_en = window.location.href.indexOf('ringbuilder-lab-colored-diamond');
    var ringbuilder_lab_color_diamond_de = window.location.href.indexOf('ringbuilder-laborfarbiger-diamant');    
  
    if(ringbuilder_loose_diamond_en > 0 || ringbuilder_loose_diamond_de > 0 || ringbuilder_loose_color_diamond_en > 0 || ringbuilder_loose_color_diamond_de > 0 || ringbuilder_lab_diamond_en > 0 || ringbuilder_lab_diamond_de > 0 || ringbuilder_lab_color_diamond_en > 0 || ringbuilder_lab_color_diamond_de > 0) {      
       if(localStorage.getItem("ring_setting") != null){
          var ringsetting_details = jQuery.parseJSON(ring_setting);
          if(ringsetting_details[0].minimum_carat_total_weight != '' && ringsetting_details[0].maximum_carat_total_weight != ''){
            var min_carat = parseFloat(ringsetting_details[0].minimum_carat_total_weight).toFixed(2);
            var max_carat = parseFloat(ringsetting_details[0].maximum_carat_total_weight).toFixed(2);    
          }
       }
    }

    var pendant_setting = localStorage.getItem("pendant_setting");
    var pendantbuilder_loose_diamond_en = window.location.href.indexOf('pendantbuilder-natural-white-diamond');
    var pendantbuilder_loose_diamond_de = window.location.href.indexOf('pendantbuilder-naturlicher-weisser-diamant');
    var pendantbuilder_loose_color_diamond_en = window.location.href.indexOf('pendantbuilder-natural-colored-diamond');
    var pendantbuilder_loose_color_diamond_de = window.location.href.indexOf('pendantbuilder-naturlicher-farbiger-diamant');
    var pendantbuilder_lab_diamond_en = window.location.href.indexOf('pendantbuilder-lab-white-diamond');
    var pendantbuilder_lab_diamond_de = window.location.href.indexOf('pendantbuilder-labor-weisser-diamant');
    var pendantbuilder_lab_color_diamond_en = window.location.href.indexOf('pendantbuilder-lab-colored-diamond');
    var pendantbuilder_lab_color_diamond_de = window.location.href.indexOf('pendantbuilder-laborfarbiger-diamant');

    if(pendantbuilder_loose_diamond_en > 0 || pendantbuilder_loose_diamond_de > 0 || pendantbuilder_loose_color_diamond_en > 0 || pendantbuilder_loose_color_diamond_de > 0 || pendantbuilder_lab_diamond_en > 0 || pendantbuilder_lab_diamond_de > 0 || pendantbuilder_lab_color_diamond_en > 0 || pendantbuilder_lab_color_diamond_de > 0) {      
       if(localStorage.getItem("pendant_setting") != null){
           var pendantsetting_details = jQuery.parseJSON(pendant_setting);         
           if(pendantsetting_details[0].minimum_carat_total_weight != '' && pendantsetting_details[0].maximum_carat_total_weight != ''){
              var min_carat = parseFloat(pendantsetting_details[0].minimum_carat_total_weight).toFixed(2);
              var max_carat = parseFloat(pendantsetting_details[0].maximum_carat_total_weight).toFixed(2);   
           }         
       }
    }

    var earring_setting = localStorage.getItem("earring_setting");
    var earringbuilder_loose_diamond_en = window.location.href.indexOf('earringbuilder-natural-white-diamond');
    var earringbuilder_loose_diamond_de = window.location.href.indexOf('earringbuilder-naturlicher-weisser-diamant');
    var earringbuilder_loose_color_diamond_en = window.location.href.indexOf('earringbuilder-natural-colored-diamond');
    var earringbuilder_loose_color_diamond_de = window.location.href.indexOf('earringbuilder-naturlicher-farbiger-diamant');
    var earringbuilder_lab_diamond_en = window.location.href.indexOf('earringbuilder-lab-white-diamond');
    var earringbuilder_lab_diamond_de = window.location.href.indexOf('earringbuilder-labor-weisser-diamant');
    var earringbuilder_lab_color_diamond_en = window.location.href.indexOf('earringbuilder-lab-colored-diamond');
    var earringbuilder_lab_color_diamond_de = window.location.href.indexOf('earringbuilder-laborfarbiger-diamant');

    if(earringbuilder_loose_diamond_en > 0 || earringbuilder_loose_diamond_de > 0 || earringbuilder_loose_color_diamond_en > 0 || earringbuilder_loose_color_diamond_de > 0 || earringbuilder_lab_diamond_en > 0 || earringbuilder_lab_diamond_de > 0 || earringbuilder_lab_color_diamond_en > 0 || earringbuilder_lab_color_diamond_de > 0) {      
       if(localStorage.getItem("earring_setting") != null){
           var earringsetting_details = jQuery.parseJSON(earring_setting);         
           if(earringsetting_details[0].minimum_carat_total_weight != '' && earringsetting_details[0].maximum_carat_total_weight != ''){
              var min_carat = parseFloat(earringsetting_details[0].minimum_carat_total_weight).toFixed(2);
              var max_carat = parseFloat(earringsetting_details[0].maximum_carat_total_weight).toFixed(2);   
           }         
       }
    }
  
   var isSelected = false;      
 
    //session carat filter selected     
     if(parseFloat(start).toFixed(2) != min_carat || parseFloat(end).toFixed(2) != max_carat){
       isSelected = true;
     }    
    
    var caratTitle = caratFilterUnit+': '+start + ' '+caratFilterUnit+' - '+end + ' '+caratFilterUnit;
       
     setSelectedFilter(caratTitle,"carat_slider_render('"+min_carat+"', '"+max_carat+"','true')",isSelected,'carat');
     //end
  
	jQuery("#carat-slider").slider({      
		range: true,
		min: 0,
		max: carat.length - 1,
		values: [start1, end1],
        step: 1,
		slide: function(event, ui) {    
            emptyResultDiv();          
			if ((ui.values[0] > ui.values[1])) {
				return false;
			}
			//disable min max slider if setting selected
			if (settingSelected == 1 && (parseFloat(start) > parseFloat(carat[parseInt(ui.values[0])]) || parseFloat(end) < parseFloat(carat[parseInt(ui.values[1])]))) {
				return false;
			}
          
			$("#carat_from").val(carat[parseInt(ui.values[0])]+' '+caratFilterUnit);
			$('#carat_left_hidden').val(carat[parseInt(ui.values[0])]);
			$('#carat_to').val(carat[parseInt(ui.values[1])]+' '+caratFilterUnit);
			$('#carat_right_hidden').val(carat[parseInt(ui.values[1])]);          
		},
		change: function(event, ui) {   
            emptyResultDiv();
			if ((ui.values[0] > ui.values[1])) {
				return false;
			}			

			if (option) {                  
				jQuery('#page_no').val(1);
				jQuery('#pagination').val('');   
                 
                //applied filter code start here                              
                 var isSelected = false;                        
                 if(carat[parseInt(ui.values[0])] != min_carat || carat[parseInt(ui.values[1])] != max_carat){
                       isSelected = true;
                 }                
                
                 setTimeout(function(){                  
                  var caratLeft = $('#carat_left_hidden').val();
                  var caratRight = $('#carat_right_hidden').val();
                             
                  var caratTitle = caratFilterUnit+': '+caratLeft+ ' '+caratFilterUnit+' - '+caratRight+ ' '+caratFilterUnit;
                   
                  setSelectedFilter(caratTitle,"carat_slider_render('"+min_carat+"', '"+max_carat+"','true')",isSelected,'carat');
                  //end 
                  
                  graphqlDataCall(1);   
                 }, 20);    			               
			}
           
		}

	});
    
    start = start ? start : minDiamondCarat;
    $("#carat_from").val(start+' '+caratFilterUnit);
    $("#carat_to").val(end+' '+caratFilterUnit);
    $('#carat_left_hidden').val(start);
    $('#carat_right_hidden').val(end);    
}


function replace_carat_from() {    
	var min_carat_value = minDiamondCarat;
	var settingSelected = jQuery("#setting").val();

	if (jQuery('#carat_from').val() == '') {
		var value = parseFloat(jQuery('#carat_left_hidden').val()).toFixed(2);
		jQuery('#carat_from').val(parseFloat(value).toFixed(2)+' '+caratFilterUnit);
		return false;
	} else {
		var hidden_carat_value = parseFloat($('#carat_left_hidden').val()).toFixed(2);
		var carat_value = parseFloat(jQuery('#carat_from').val()).toFixed(2);
	}
	
	var value = carat_value;
	var carat_value1_comma = value;
	value = carat_value1_comma;

	var value1 = parseFloat($('#carat_to').val());
 
	if (isNaN(value) != false) {
		var value = parseFloat(minDiamondCarat).toFixed(2);
		 if(store_lang == 'de'){
          alert("Bitte geben Sie den Wert in Zahlen ein");
        }else if(store_lang == 'fr'){
           alert("Veuillez entrer la valeur en chiffres.");
        }else if(store_lang == 'it'){
           alert("Si prega di inserire il valore in numero.");
         }else{
          alert("Please enter value in number");
        }
		jQuery('#carat_from').val(value + ' Karat');
	} else if (value > value1) {
		if(store_lang == 'de'){
          alert("Falscher Karat Angabe!");
        }else if(store_lang == 'fr'){
           alert("Plage de carats incorrecte !");
        }else if(store_lang == 'it'){
            alert("Gamma di carati non valida!");
         }
         else{
         alert('Incorrect carat range!');
        }
		$('#carat_from').val(parseFloat(hidden_carat_value).toFixed(2)+' '+caratFilterUnit);
		return false;
	} else if (carat_value < min_carat_value) {
		if(store_lang == 'de'){
          alert("Falscher Karat Angabe!");
        }else if(store_lang == 'fr'){
           alert('Plage de carats incorrecte !');
        }else if(store_lang == 'it'){
            alert('Gamma di carati non valida!');
         }else{
         alert('Incorrect carat range!');
        }
		$('#carat_from').val((parseFloat(min_carat_value).toFixed(2))+" "+caratFilterUnit);
		carat_slider_render(min_carat_value, value1, true);
		return false;
	} else if (settingSelected == 1 && (hidden_carat_value > carat_value)) {
      if(store_lang == 'de'){
        alert('Die gewählte Fassung passt zu einem Diamanten größer als ' + carat_value);
      }else if(store_lang == 'fr'){
        alert('Le réglage sélectionné peut correspondre à un diamant supérieur à ' + carat_value);
      }else if(store_lang == 'it'){
        alert('Limpostazione selezionata può corrispondere a un diamante maggiore di ' + carat_value);
      }else{
        alert('selected setting can match with diamond greater than ' + carat_value);
      }		
		jQuery('#carat_from').val(hidden_carat_value+" "+caratFilterUnit);
		return false;
	}
	$('#carat_left_hidden').val(value);
	$('#carat_right_hidden').val(value1);
    
	carat_slider_render(value, value1, true);

}

function replace_carat_to() {
	var max_carat_value = parseFloat(maxDiamondCarat).toFixed(2);
	var settingSelected = jQuery("#setting").val();
   
	if (jQuery('#carat_to').val() == '') {
		var value = parseFloat(jQuery('#carat_right_hidden').val()).toFixed(2);
		jQuery('#carat_to').val(parseFloat(value).toFixed(2)+' '+caratFilterUnit);
		return false;
	} else {
		var hidden_carat_value = parseFloat(jQuery('#carat_right_hidden').val()).toFixed(2);
		var carat_value = parseFloat(jQuery('#carat_to').val()).toFixed(2);
	}   

	value = carat_value;
	var carat_value1_comma = value;
	value = carat_value1_comma;

	var value1 = parseFloat($('#carat_from').val());
    
	if (isNaN(value) != false) {
		var value = parseFloat(maxDiamondCarat).toFixed(2);        
		if(store_lang == 'de'){
          alert("Bitte geben Sie den Wert in Zahlen ein");
        }else if(store_lang == 'fr'){
          alert("Veuillez entrer la valeur en chiffres.");
        }else if(store_lang == 'it'){
          alert("Si prega di inserire il valore in numero.");
        }else{
          alert("Please enter value in number");
        }
		jQuery('#carat_to').val(value + ' '+caratFilterUnit);
	} else if (parseFloat(value) > parseFloat(max_carat_value)) {		
		if(store_lang == 'de'){
          alert("Falscher Karat Angabe!");
        }else if(store_lang == 'fr'){
          alert("Plage de carats incorrecte !");
        }else if(store_lang == 'it'){
          alert("Gamma di carati non valida!");
        }else{
          alert("Incorrect carat range!");
        }
		jQuery('#carat_to').val(hidden_carat_value+" "+caratFilterUnit);
		return false;
	} else if (value1 > value) {
		if(store_lang == 'de'){
          alert("Falscher Karat Angabe!");
        }else if(store_lang == 'fr'){
          alert("Plage de carats incorrecte !");
        }else if(store_lang == 'it'){
          alert("Gamma di carati non valida!");
        }else{
          alert("Incorrect carat range!");
        }
		$('#carat_to').val(hidden_carat_value+' '+caratFilterUnit);
		return false;
	}else if (settingSelected == 1 && (hidden_carat_value < carat_value)) {
        if(store_lang == 'de'){
          alert('Die gewählte Fassung passt zu einem Diamanten mit weniger als ' + carat_value);
        }else if(store_lang == 'fr'){
          alert('Le réglage sélectionné peut correspondre à un diamant inférieur à ' + carat_value);
        }else if(store_lang == 'it'){
          alert('Limpostazione selezionata può corrispondere a un diamante inferiore a ' + carat_value);
        }else{
          alert('Selected setting can match with diamond less than ' + carat_value);
        }
		
		jQuery('#carat_to').val(hidden_carat_value+" "+caratFilterUnit);
		return false;
	}
   
	$('#carat_right_hidden').val(value);
	$('#carat_left_hidden').val(value1);

	carat_slider_render(value1, value, true);
}
/*** Diamond Carat Filter End ***/

/*** Diamond Price Filter End ***/
var price = [];
var minDiamondPrice = $('#diamondMinprice').val();
var maxDiamondPrice = $('#diamondMaxprice').val();
var setting_price;


for (var i = parseInt(minDiamondPrice); (i < 2500 && i<maxDiamondPrice); i = i+1) {
    price.push(i);
  };
for (var i = 2500; i < 5000; i = i+10) {
  price.push(i);
};
for (var i = 5000; i < 7000; i = i+15) {
  price.push(i);
};
for (var i = 7000; i < 10000; i = i+1) {
  price.push(i);
};
for (var i = 10000; i < 15000; i = i+25) {
  price.push(i);
};
for (var i = 15000; i < 25000; i = i+200) {
  price.push(i);
};
for (var i = 25000; i < 50000; i = i+300) {
  price.push(i);
};
for (var i = 50000; i < 100000; i = i+500) {
  price.push(i);
};
for (var i = 100000; i < 150000; i = i+1000) {
  price.push(i);
};
for (var i = 150000; i <= 1000000; i = i+5000) {
  price.push(i);
};
price.push(parseInt(maxDiamondPrice));

function addCommas(price) {
	price += '';
	x = price.split('.');
	x1 = x[0];
	x2 = x.length > 1 ? '.' + x[1] : '';
	var rgx = /(\d+)(\d{3})/;
	while (rgx.test(x1)) {
		x1 = x1.replace(rgx, '$1' + ',' + '$2');
	}
	return x1 + x2;
}


var diamondMinprice = $('#diamondMinprice').val();
var diamondMaxprice = $('#diamondMaxprice').val();

    var loose_diamond_en = window.location.href.indexOf('diamond-search');
    var loose_diamond_fr = window.location.href.indexOf('achat-diamants');
    var loose_diamond_in = window.location.href.indexOf('acquistare-diamanti');
    var loose_diamond_de = window.location.href.indexOf('diamanten-kaufen');
    var loose_color_diamond_en = window.location.href.indexOf('natural-colored-diamond');
    var loose_color_diamond_fr = window.location.href.indexOf('naturlicher-farbiger-diamant');
    var loose_color_diamond_it = window.location.href.indexOf('diamante-di-colore-naturale');
    var loose_color_diamond_de = window.location.href.indexOf('naturlicher-farbiger-diamant');
    var lab_diamond_en = window.location.href.indexOf('lab-white-diamond');
var lab_diamond_fr = window.location.href.indexOf('labor-weisser-diamant');
var lab_diamond_it = window.location.href.indexOf('diamante-bianco-da-laboratorio');
    var lab_diamond_de = window.location.href.indexOf('labor-weisser-diamant');
    var lab_color_diamond_en = window.location.href.indexOf('lab-colored-diamond');
var lab_color_diamond_fr = window.location.href.indexOf('laborfarbiger-diamant');
var lab_color_diamond_it = window.location.href.indexOf('diamante-colorato-in-laboratorio');
    var lab_color_diamond_de = window.location.href.indexOf('laborfarbiger-diamant');
    var gemstone_en = window.location.href.indexOf('gemstones');
    var gemstone_de = window.location.href.indexOf('edelsteine');
    var gemstone_fr = window.location.href.indexOf('pierres-precieuses');
    var gemstone_it = window.location.href.indexOf('pietre-preziose');
   var pendantbuilder_loose_color_diamond_en = window.location.href.indexOf('pendantbuilder-natural-colored-diamond');
    var pendantbuilder_loose_color_diamond_de = window.location.href.indexOf('pendantbuilder-naturlicher-farbiger-diamant');

function price_slider_render(start,end,option){

   option = option === "true" || option === true;
 //   console.log("Option value before condition:", option, "Type:", typeof option);
  
    var start2=getClosestNum(start,price);
    var end2=getClosestNum(end,price);  
    var start1=get_priceindex(start2); 
    var start11=get_priceindex(start);
    var end11=get_priceindex(end);
    var end1=get_priceindex(end2);  

    

    if(loose_diamond_en > 0 || loose_diamond_fr > 0 || loose_diamond_de > 0 ||  loose_diamond_de > 0 || loose_color_diamond_en > 0 || loose_color_diamond_fr > 0 || loose_color_diamond_it > 0 || loose_color_diamond_de > 0 || lab_diamond_en > 0 || lab_diamond_fr > 0 || lab_diamond_it > 0 || lab_diamond_de > 0 || lab_color_diamond_en > 0 || lab_color_diamond_fr > 0 || lab_color_diamond_it > 0 || lab_color_diamond_de > 0 || gemstone_en > 0 || gemstone_de > 0 || gemstone_fr > 0 || gemstone_it > 0 ) {
      if(store_lang == 'de'){
        var priceHeadTitle = 'Preis:';
      }else if(store_lang == 'fr'){
        var priceHeadTitle = 'Prix:';
      }else if(store_lang == 'it'){
        var priceHeadTitle = 'Prezzo:';
      }else{
        var priceHeadTitle = 'Price:';
      }
    }else{
      if(store_lang == 'de'){
        var priceHeadTitle = 'Gesamtpreis:';
      }else if(store_lang == 'fr'){
        var priceHeadTitle = 'Prix-Total:';
      }else if(store_lang == 'it'){
        var priceHeadTitle = 'Prezzo-Totale:';
      }else{
        var priceHeadTitle = 'Total-Price:';
      }
    }
  
    

    //session price filter selected
    var isSelected = false;
    if(start != diamondMinprice || end != diamondMaxprice){
       isSelected = true;
    }

   
    var priceTitle = priceHeadTitle+' '+Shopify.formatMoney(start*100, theme.moneyFormat)+' - '+Shopify.formatMoney(end*100, theme.moneyFormat);    
  
    // console.log('priceTitle',priceTitle);
    setSelectedFilter(priceTitle,"price_slider_render('"+diamondMinprice+"', '"+diamondMaxprice+"','true')",isSelected,'price');
     //end
    
        jQuery("#price-slider").slider({
            range: true,
            min: 0,
            max: price.length-1,
            values: [ start1,end1 ],
            step:0.1,
            slide: function( event, ui ) { 
                if ((ui.values[0]) > (ui.values[1])) { 
                    return false; 
                }
               jQuery('#price_left_hidden').val(price[parseInt(ui.values[0])]);
               jQuery('#price_right_hidden').val(price[parseInt(ui.values[1])]);
  
               var price_form = ""+Shopify.formatMoney(price[parseInt(ui.values[0])].toFixed(0)*100, theme.moneyFormat);
               jQuery('#price_from').val(price_form);
               var price_to = ""+Shopify.formatMoney(price[parseInt(ui.values[1])].toFixed(0)*100, theme.moneyFormat);
               jQuery('#price_to').val(price_to);
                          
            },
            change: function(event, ui) {              
           //   console.log("Option value before condition:", option, "Type:", typeof option);
              if(option == true) {     
            //    console.log("Inside the TRUE condition");
                emptyResultDiv();       
               
                 jQuery('#price_left_hidden').val(price[parseInt(ui.values[0])]);
                 jQuery('#price_right_hidden').val(price[parseInt(ui.values[1])]);
                  
                 var price_form = ""+Shopify.formatMoney(price[parseInt(ui.values[0])].toFixed(0)*100, theme.moneyFormat);
                 jQuery('#price_from').val(price_form);
                 var price_to = ""+Shopify.formatMoney(price[parseInt(ui.values[1])].toFixed(0)*100, theme.moneyFormat);
                 jQuery('#price_to').val(price_to);
                  
                 //applied filters 
                 var isSelected = false;
                 
                 if(price[parseInt(ui.values[0])] != diamondMinprice || price[parseInt(ui.values[1])] != diamondMaxprice){
                       isSelected = true;
                 }           
                
                 var priceTitle = priceHeadTitle+' '+price_form+' - '+price_to;          
                 
                 setSelectedFilter(priceTitle,"price_slider_render('"+diamondMinprice+"', '"+diamondMaxprice+"','true')",isSelected,'price');
                 //end                               
                 
                  jQuery('#page_no').val(1);
                  jQuery('#pagination').val('');
                 if(loose_diamond_en > 0 || loose_diamond_de > 0 || loose_color_diamond_en > 0 || loose_color_diamond_de > 0 || lab_diamond_en > 0 || lab_diamond_de > 0 || lab_color_diamond_en > 0 || lab_color_diamond_de > 0 || gemstone_en > 0 || gemstone_de > 0){
                   
                 }else{
                      // Show Loader
                      if (setting_price !== undefined && setting_price !== null){
                         jQuery(".price_from_div,.price_to_div").addClass('active');
                        jQuery("#price_loader_l").show();
                        jQuery("#price_loader_r").show();
                      }
                }
                
                  graphqlDataCall(1);
              //  console.log('true');
	 			}else if(option == false){
               //   console.log('false');
                   jQuery('#price_left_hidden').val(start);
                   jQuery('#price_right_hidden').val(end);
      
                   var price_form = ""+Shopify.formatMoney(start*100, theme.moneyFormat);
                   jQuery('#price_from').val(price_form);
                   var price_to = ""+Shopify.formatMoney(end*100, theme.moneyFormat);
                   jQuery('#price_to').val(price_to);

                   jQuery('#page_no').val(1);
                   jQuery('#pagination').val('');

                if(loose_diamond_en > 0 || loose_diamond_de > 0 || loose_color_diamond_en > 0 || loose_color_diamond_de > 0 || lab_diamond_en > 0 || lab_diamond_de > 0 || lab_color_diamond_en > 0 || lab_color_diamond_de > 0 || gemstone_en > 0 || gemstone_de > 0){
                   
                 }else{
                  // Show Loader
                if (setting_price !== undefined && setting_price !== null){
                   jQuery(".price_from_div,.price_to_div").addClass('active');
                  jQuery("#price_loader_l").show();
                  jQuery("#price_loader_r").show();
                }
                }
                
                
                setTimeout(function(){
                   graphqlDataCall(1);
                  }, 10);

                  setTimeout(function(){
                     option = true;
                   }, 5); 
                   return false;
                }
              slide = '';
            }
             
        });
  		  
          var start_num = parseInt(start);
          var end_num = parseInt(end);
	
          var start_dec= start_num.toFixed(0);
          var end_dec= end_num.toFixed(0);
  
         jQuery('#price_left_hidden').val(start_dec);
         jQuery('#price_right_hidden').val(end_dec);  		 
         jQuery('#price_from').val(Shopify.formatMoney(start_dec*100, theme.moneyFormat));  
  		 jQuery('#price_to').val(Shopify.formatMoney(end_dec*100, theme.moneyFormat));
}


function get_priceindex(value) {
	var pos = 0
	for (i = 0; i < price.length; i++) {
		if (price[i] == value) {
			pos = i;
			break;
		}
	}
	return pos;
}


/*** Price Validation Start ***/
$("#price_to").keypress(function(e) {
	//if the letter is not digit then display error and don't type anything
	if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
		return false;
	}
});

$("#price_from").keypress(function(e) {
	//if the letter is not digit then display error and don't type anything
	if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
		return false;
	}
});
/*** Price Validation End ***/

function replace_price_to() {

	if (jQuery('#price_to').val() == '') {
		var value = parseFloat(jQuery('#price_right_hidden').val());
        var formatted_price = ""+Shopify.formatMoney(value*100, theme.moneyFormat);
		jQuery('#price_to').val(formatted_price);        
		return false;
	} else {
		var value = jQuery('#price_to').val().toString().trim();

        // Clean input early – remove currency symbols, commas, spaces, etc.
        value = value.replace(/[^\d.,]/g, '');

        // Convert comma to dot if present (for EU formats)
        if (value.indexOf(',') > -1 && value.indexOf('.') === -1) {
            value = value.replace(',', '.');
        } else {
            value = value.replace(/,/g, '');
        }

        var exchangeRate = parseFloat(Shopify.currency.rate || 1).toFixed(2);

        if (typeof setting_price !== "undefined" && setting_price !== null && setting_price !== '' && !isNaN(setting_price)) {             
            setting_price = parseFloat(setting_price);  // Ensure it's a number
            value = parseFloat(value);                  // Clean float before subtracting
            value = value - setting_price;
            value = Math.round(value / exchangeRate);
            value = value.toString().replace('€', '').trim();  
        } else {               
            value = parseFloat(value);                  // Clean float
            value = Math.round(value / exchangeRate);
            value = value.toString().replace('€', '').trim();
        }               
	}

	var value1 = jQuery('#price_left_hidden').val(); 

	if(value.indexOf('.') != -1){    
      value = value.replace(/\./g, '');
  	  value1 = value1.replace(/\./g, '');    
    }else if(value.indexOf(',') != -1){
       value = value.replace(/[^\d\.]/g, '');
       value1 = value1.replace(/[^\d\.]/g, '');
    }

	value = parseInt(value);
	value1 = parseInt(value1);

	if (isNaN(value)) {
		value = maxDiamondPrice;
		if(store_lang == 'de'){
          alert("Bitte geben Sie den Wert in Zahlen ein");
        }else if(store_lang == 'fr'){
          alert("Veuillez entrer la valeur en chiffres.");
        }else if(store_lang == 'it'){
          alert("Si prega di inserire il valore in numero.");
        }else{
          alert("Please enter value in number");
        }

        // Reset fallback value
		var fallback = parseFloat(jQuery('#price_right_hidden').val());
        var formatted_price = ""+Shopify.formatMoney(fallback*100, theme.moneyFormat);
		jQuery('#price_to').val(formatted_price);
		return false;
	} else if (value > maxDiamondPrice) {   
        if(store_lang == 'de'){
          alert("Falsche Preisspanne!");
        }else if(store_lang == 'fr'){
          alert('Plage de prix incorrecte !');
        }else if(store_lang == 'it'){
          alert('Gamma di prezzo non valida!');
        }else{
          alert('Incorrect price range!');
        }

		var valLimit = parseFloat(jQuery('#price_right_hidden').val());
        var formatted_price = ""+Shopify.formatMoney(valLimit*100, theme.moneyFormat);
		jQuery('#price_to').val(formatted_price);        
		return false;
	} else if (value1 > value) {      
		if(store_lang == 'de'){
          alert("Falsche Preisspanne!");
        }else if(store_lang == 'fr'){
          alert('Plage de prix incorrecte !');
        }else if(store_lang == 'it'){
          alert('Gamma di prezzo non valida!');
        }else{
          alert('Incorrect price range!');
        }

		var valLimit = parseFloat(jQuery('#price_right_hidden').val());
        var formatted_price = ""+Shopify.formatMoney(valLimit*100, theme.moneyFormat);
		jQuery('#price_to').val(formatted_price);        
		return false;
	} else if (value1 == '') {
		jQuery('#price_from').val(value1);
	}

	jQuery('#price_right_hidden').val(value.toFixed(0));
	jQuery('#price_left_hidden').val(value1.toFixed(0));
	price_slider_render(value1, value, false);
}


function replace_price_from() {

	if (jQuery('#price_from').val() == '') {
		var value = parseFloat(jQuery('#price_left_hidden').val());          
        var formatted_price = "" + Shopify.formatMoney(value * 100, theme.moneyFormat);
		jQuery('#price_from').val(formatted_price);
		return false;
	} else {
		var value = jQuery('#price_from').val().toString().trim();

        // Clean input early – remove currency symbols, commas, etc.
        value = value.replace(/[^\d.,]/g, '');

        // Convert comma to dot if necessary
        if (value.indexOf(',') > -1 && value.indexOf('.') === -1) {
            value = value.replace(',', '.');
        } else {
            value = value.replace(/,/g, '');
        }

        var exchangeRate = parseFloat(Shopify.currency.rate || 1).toFixed(2);

        if (typeof setting_price !== "undefined" && setting_price !== null && setting_price !== '' && !isNaN(setting_price)) {
            setting_price = parseFloat(setting_price);
            value = parseFloat(value);  // Ensure number before calculation
            value = value - setting_price;  
            value = Math.round(value / exchangeRate);
            value = value.toString().replace('€', '').trim(); 
        } else {
            value = parseFloat(value);  // Ensure number
            value = Math.round(value / exchangeRate);
            value = value.toString().replace('€', '').trim();
        }

        // console.log('value', value);
	}

	var value1 = jQuery('#price_right_hidden').val();

	if (value.indexOf('.') != -1) {    
      value = value.replace(/\./g, '');
      value1 = value1.replace(/\./g, '');    
    } else if (value.indexOf(',') != -1) {
       value = value.replace(/[^\d\.]/g, '');
       value1 = value1.replace(/[^\d\.]/g, '');
    }

	value = parseInt(value);
	value1 = parseInt(value1);

	if (isNaN(value)) {
		value = minDiamondPrice;

		if (store_lang == 'de') {
			alert("Bitte geben Sie den Wert in Zahlen ein");
		} else if (store_lang == 'fr') {
			alert('Veuillez entrer la valeur en chiffres.');
		} else if (store_lang == 'it') {
			alert('Si prega di inserire il valore in numero.');
		} else {
			alert('Please enter value in number');
		}

		var formatted_price = "" + Shopify.formatMoney(value * 100, theme.moneyFormat);
		jQuery('#price_from').val(formatted_price);
	} else if (value < minDiamondPrice) {
		if (store_lang == 'de') {
			alert("Falsche Preisspanne!");
		} else if (store_lang == 'fr') {
			alert('Plage de prix incorrecte !');
		} else if (store_lang == 'it') {
			alert('Gamma di prezzo non valida!');
		} else {
			alert('Incorrect price range!');
		}

		var valLimit = parseFloat(jQuery('#price_left_hidden').val());        
        var formatted_price = "" + Shopify.formatMoney(valLimit * 100, theme.moneyFormat);
		jQuery('#price_from').val(formatted_price);
		return false;
	} else if (value > value1) {
		if (store_lang == 'de') {
			alert("Falsche Preisspanne!");
		} else if (store_lang == 'fr') {
			alert('Plage de prix incorrecte !');
		} else if (store_lang == 'it') {
			alert('Gamma di prezzo non valida!');
		} else {
			alert('Incorrect price range!');
		}

		price_slider_render(price[0], value1, false);
		return false;
	}

	jQuery('#price_left_hidden').val(value.toFixed(0));
	jQuery('#price_right_hidden').val(value1.toFixed(0));
	price_slider_render(value, value1, false);
}


/*** Diamond Price Filter End ***/

/*** Diamond Depth Filter Start ***/
var minDiamondDepth = parseFloat($('#diamondMindepth').val());
var maxDiamondDepth = parseFloat($('#diamondMaxdepth').val());

var depth = [];
for (i = minDiamondDepth; i < 20; i = i + 0.01) {
	var dec = i.toFixed(2);
	depth.push(dec);
}
for (i = 20; i < 60.00; i = i + 0.30) {
	var dec = i.toFixed(2);
	depth.push(dec);
}
for (i = 60; i < 71; i = i + 0.60) {
	var dec = i.toFixed(2);
	depth.push(dec);
}
for (i = 71; i < maxDiamondDepth; i = i + 0.65) {
	var dec = i.toFixed(2);
	depth.push(dec);
}
depth.push(maxDiamondDepth);

Shopify.money_format = '&pound;{{amount}}';
var currency_symbol = currencySymbol;

function getClosestNum(num, ar) {
	var i = 0,
		closest, closestDiff, currentDiff;
	if (ar.length) {
		closest = ar[0];
		for (i; i < ar.length; i++) {
			closestDiff = Math.abs(num - closest);
			currentDiff = Math.abs(num - ar[i]);
			if (currentDiff < closestDiff) {
				closest = ar[i];
			}
			closestDiff = null;
			currentDiff = null;
		}
      
		//returns first element that is closest to number
		return closest;
	}
	//no length
	return false;
}

// function get_index(value, array) {
// 	var pos = 0
// 	for (i = 0; i < array.length; i++) {
// 		if (array[i] == value) {
// 			pos = i;
// 			break;
// 		}
// 	}
// 	return pos;
// }
function get_index(value, array) {
  var pos = 0;
  for (let i = 0; i < array.length; i++) {
    if (parseFloat(array[i]).toFixed(2) == parseFloat(value).toFixed(2)) {
      pos = i;
      break;
    }
  }
  return pos;
}


if(store_lang == 'de'){
  var depthFilterUnit = 'Tiefe';
}else{
  var depthFilterUnit = 'Depth';
}  
function depth_slider_render(start, end, option) { 
    jQuery('.tps-diamondlist-result-list-view-loader').show();
    jQuery('.tps-diamondlist-result-grid-view-loader').show();
  
  var start2 = getClosestNum(start, depth);
	var end2 = getClosestNum(end, depth);   
	var start1 = get_index(start2, depth);
	var start11 = get_index(start, depth);
	var end11 = get_index(end, depth);
	var end1 = get_index(end2, depth);
      
	var settingSelected = jQuery("#setting").val();

    var min_depth = parseFloat($("#diamondMindepth").val()).toFixed(2);
    var max_depth = parseFloat($("#diamondMaxdepth").val()).toFixed(2);    
    
      
   var isSelected = false;      
 
    //session depth filter selected     
     if(parseFloat(start).toFixed(2) != min_depth || parseFloat(end).toFixed(2) != max_depth){
       isSelected = true;
     }    
    
    var depthTitle = depthFilterUnit+': '+start + ' % - '+end + ' %';
       
     setSelectedFilter(depthTitle,"depth_slider_render('"+min_depth+"', '"+max_depth+"','true')",isSelected,'depth');
     //end
  
	jQuery("#depth-slider").slider({      
		range: true,
		min: 0,
		max: depth.length - 1,
		values: [start1, end1],
        step: 1,
		slide: function(event, ui) {    
            emptyResultDiv();          
			if ((ui.values[0] > ui.values[1])) {
				return false;
			}
			//disable min max slider if setting selected
			if (settingSelected == 1 && (parseFloat(start) > parseFloat(depth[parseInt(ui.values[0])]) || parseFloat(end) < parseFloat(depth[parseInt(ui.values[1])]))) {
				return false;
			}
          
			$("#depth_from").val(depth[parseInt(ui.values[0])]+' %');
			$('#depth_left_hidden').val(depth[parseInt(ui.values[0])]);
			$('#depth_to').val(depth[parseInt(ui.values[1])]+' %');
			$('#depth_right_hidden').val(depth[parseInt(ui.values[1])]);          
		},
		change: function(event, ui) {   
            emptyResultDiv();
			if ((ui.values[0] > ui.values[1])) {
				return false;
			}			

			if (option) {                  
				jQuery('#page_no').val(1);
				jQuery('#pagination').val('');   
                 
                //applied filter code start here                              
                 var isSelected = false;                        
                 if(depth[parseInt(ui.values[0])] != min_depth || depth[parseInt(ui.values[1])] != max_depth){
                       isSelected = true;
                 }                
                
                 setTimeout(function(){                  
                  var depthLeft = $('#depth_left_hidden').val();
                  var depthRight = $('#depth_right_hidden').val();
                             
                  var depthTitle = depthFilterUnit+': '+depthLeft+ ' % - '+depthRight+ ' %';
                   
                  setSelectedFilter(depthTitle,"depth_slider_render('"+min_depth+"', '"+max_depth+"','true')",isSelected,'depth');
                  //end 
                  
                  graphqlDataCall(1);   
                 }, 20);    			               
			}
           
		}

	});
    
    start = start ? start : minDiamonddepth;
    $("#depth_from").val(start+' %');
    $("#depth_to").val(end+' %');
    $('#depth_left_hidden').val(start);
    $('#depth_right_hidden').val(end);    
}


function replace_depth_from() {    
	var min_depth_value = minDiamondDepth;
	var settingSelected = jQuery("#setting").val();

	if (jQuery('#depth_from').val() == '') {
		var value = parseFloat(jQuery('#depth_left_hidden').val()).toFixed(2);
		jQuery('#depth_from').val(parseFloat(value).toFixed(2)+' %');
		return false;
	} else {
		var hidden_depth_value = parseFloat($('#depth_left_hidden').val()).toFixed(2);
		var depth_value = parseFloat(jQuery('#depth_from').val()).toFixed(2);
	}
	
	var value = depth_value;
	var depth_value1_comma = value;
	value = depth_value1_comma;

	var value1 = parseFloat($('#depth_to').val());
 
	if (isNaN(value) != false) {
		var value = parseFloat(minDiamonddepth).toFixed(2);
		 if(store_lang == 'de'){
          alert("Bitte geben Sie den Wert in Zahlen ein");
        }else if(store_lang == 'fr'){
           alert("Veuillez entrer la valeur en chiffres.");
        }else if(store_lang == 'it'){
           alert("Si prega di inserire il valore in numero.");
        }else{
          alert("Please enter value in number");
        }
		jQuery('#depth_from').val(value + ' Tiefe');
	} else if (value > value1) {
		if(store_lang == 'de'){
          alert("Falscher Tiefe Angabe!");
        }else if(store_lang == 'fr'){
           alert('Plage de profondeur incorrecte !');
        }else if(store_lang == 'it'){
           alert('Gamma di profondità non valida!');
        }else{
         alert('Incorrect depth range!');
        }
		$('#depth_from').val(parseFloat(hidden_depth_value).toFixed(2)+' %');
		return false;
	} else if (depth_value < min_depth_value) {
		if(store_lang == 'de'){
          alert("Falscher Tiefe Angabe!");
        }else if(store_lang == 'fr'){
           alert('Plage de profondeur incorrecte !');
        }else if(store_lang == 'it'){
           alert('Gamma di profondità non valida!');
        }else{
         alert('Incorrect depth range!');
        }
		$('#depth_from').val((parseFloat(min_depth_value).toFixed(2))+" %");
		depth_slider_render(min_depth_value, value1, true);
		return false;
	} else if (settingSelected == 1 && (hidden_depth_value > depth_value)) {
      if(store_lang == 'de'){
        alert('Die gewählte Fassung passt zu einem Diamanten größer als ' + depth_value);
      }else if(store_lang == 'fr'){
        alert('Le réglage sélectionné peut correspondre à un diamant supérieur à ' + depth_value);
      }else if(store_lang == 'it'){
        alert('Limpostazione selezionata può corrispondere a un diamante maggiore di ' + depth_value);
      }else{
        alert('selected setting can match with diamond greater than ' + depth_value);
      }		
		jQuery('#depth_from').val(hidden_depth_value+" %");
		return false;
	}
	$('#depth_left_hidden').val(value);
	$('#depth_right_hidden').val(value1);
    
	depth_slider_render(value, value1, true);

}

function replace_depth_to() {
	var max_depth_value = parseFloat(maxDiamondDepth).toFixed(2);
	var settingSelected = jQuery("#setting").val();
   
	if (jQuery('#depth_to').val() == '') {
		var value = parseFloat(jQuery('#depth_right_hidden').val()).toFixed(2);
		jQuery('#depth_to').val(parseFloat(value).toFixed(2)+' %');
		return false;
	} else {
		var hidden_depth_value = parseFloat(jQuery('#depth_right_hidden').val()).toFixed(2);
		var depth_value = parseFloat(jQuery('#depth_to').val()).toFixed(2);
	}   

	value = depth_value;
	var depth_value1_comma = value;
	value = depth_value1_comma;

	var value1 = parseFloat($('#depth_from').val());
    
	if (isNaN(value) != false) {
		var value = parseFloat(maxDiamonddepth).toFixed(2);        
		if(store_lang == 'de'){
          alert("Bitte geben Sie den Wert in Zahlen ein");
        }else if(store_lang == 'fr'){
          alert("Veuillez entrer la valeur en chiffres.");
        }else if(store_lang == 'it'){
          alert("Si prega di inserire il valore in numero.");
        }{
          alert("Please enter value in number");
        }
		jQuery('#depth_to').val(value + ' %');
	} else if (parseFloat(value) > parseFloat(max_depth_value)) {		
		if(store_lang == 'de'){
          alert("Falscher Tiefe Angabe!");
        }else if(store_lang == 'fr'){
          alert("Plage de profondeur incorrecte !");
        }else if(store_lang == 'it'){
          alert("Gamma di profondità non valida!");
        }else{
          alert("Incorrect depth range!");
        }
		jQuery('#depth_to').val(hidden_depth_value+" %");
		return false;
	} else if (value1 > value) {
		if(store_lang == 'de'){
          alert("Falscher Tiefe Angabe!");
        }else if(store_lang == 'fr'){
          alert("Plage de profondeur incorrecte !");
        }else if(store_lang == 'it'){
          alert("Gamma di profondità non valida!");
        }else{
          alert("Incorrect depth range!");
        }
		$('#depth_to').val(hidden_depth_value+' %');
		return false;
	}else if (settingSelected == 1 && (hidden_depth_value < depth_value)) {
        if(store_lang == 'de'){
          alert('Die gewählte Fassung passt zu einem Diamanten mit weniger als ' + depth_value);
        }else if(store_lang == 'fr'){
          alert('Le réglage sélectionné peut correspondre à un diamant inférieur à ' + depth_value);
        }else if(store_lang == 'it'){
          alert('Limpostazione selezionata può corrispondere a un diamante inferiore a ' + depth_value);
        }else{
          alert('Selected setting can match with diamond less than ' + depth_value);
        }
		
		jQuery('#depth_to').val(hidden_depth_value+" %");
		return false;
	}
   
	$('#depth_right_hidden').val(value);
	$('#depth_left_hidden').val(value1);

	depth_slider_render(value1, value, true);
}
/*** Diamond depth Filter End ***/

/*** Diamond Table Filter Start ***/
var table = [];
var min_table_filter = 5.10;
var max_table_filter = 93.00;

for (i = min_table_filter; i < 6.10; i = i + 0.1) {
	var dec = i.toFixed(2);
	table.push(dec);
}
for (i = 6.10; i < 30.00; i = i + 0.10) {
	var dec = i.toFixed(2);
	table.push(dec);
}
for (i = 30.10; i < 61.00; i = i + 0.100) {
	var dec = i.toFixed(2);
	table.push(dec);
}
for (i = 61; i < max_table_filter; i = i + 0.65) {
	var dec = i.toFixed(2);
	table.push(dec);
}
table.push(max_table_filter);


  min_table_filter = parseFloat(min_table_filter).toFixed(2);
  max_table_filter  = parseFloat(max_table_filter).toFixed(2);

function table_slider_render(start, end, option) {
	start = parseFloat(start);
	end = parseFloat(end);

    var start2 = getClosestNum(start, table);
    var end2 = getClosestNum(end, table);   
    var start1 = get_index(start2, table);
    var start11 = get_index(start, table);
    var end11 = get_index(end, table);
    var end1 = get_index(end2, table);	

    var settingSelected = jQuery("#setting").val();

	// session depth filter selected
	var isSelected = false;
	if (start !== parseFloat(min_table_filter) || end !== parseFloat(max_table_filter)) {
		isSelected = true;
	}

	var tableTitle = 'Table: ' + start.toFixed(2) + ' % - ' + end.toFixed(2) + ' %';
    setSelectedFilter(tableTitle,"table_slider_render('"+min_table_filter+"', '"+max_table_filter+"','true')",isSelected,'table');

	jQuery("#table-slider").slider({
		range: true,
		min: 0,
		max: table.length - 1,
		values: [start1, end1],
        step: 1,
		slide: function (event, ui) {
			emptyResultDiv();

			if (ui.values[0] > ui.values[1]) {
				return false;
			}

			var leftVal = parseFloat(table[ui.values[0]]).toFixed(2);
			var rightVal = parseFloat(table[ui.values[1]]).toFixed(2);

          $("#table_from").val(table[parseInt(ui.values[0])]+' %');
          $('#table_left_hidden').val(table[parseInt(ui.values[0])]);
          $('#table_to').val(table[parseInt(ui.values[1])]+' %');
          $('#table_right_hidden').val(table[parseInt(ui.values[1])]); 		
		},
		change: function (event, ui) {
			emptyResultDiv();

			if (ui.values[0] > ui.values[1]) {
				return false;
			}

			if (option) {
				jQuery('#page_no').val(1);
				jQuery('#pagination').val('');

				// var leftVal = parseFloat(table[ui.values[0]]).toFixed(2);
				// var rightVal = parseFloat(table[ui.values[1]]).toFixed(2);

				// $("#table_from").val(leftVal + '%');
				// $('#table_left_hidden').val(leftVal);
				// $('#table_to').val(rightVal + '%');
				// $('#table_right_hidden').val(rightVal);
                var isSelected = false;
                if(table[parseInt(ui.values[0])] != min_table_filter || table[parseInt(ui.values[1])] != max_table_filter){
                       isSelected = true;
                 }  

				setTimeout(function(){                  
                  var tableLeft = $('#table_left_hidden').val();
                  var tableRight = $('#table_right_hidden').val();
                             
                  var tableTitle = 'Table: '+tableLeft+ ' % - '+tableRight+ ' %';
                   
                  setSelectedFilter(tableTitle,"table_slider_render('"+min_table_filter+"', '"+max_table_filter+"','true')",isSelected,'table');
                  //end 
                  
                  graphqlDataCall(1);   
                 }, 20);
			}
		}
	});

	// Set initial UI values
	start = start ? start : min_table_filter;
    $("#table_from").val(start+' %');
    $("#table_to").val(end+' %');
    $('#table_left_hidden').val(start);
    $('#table_right_hidden').val(end); 
}


function replace_table_from() {
	var min_table_value = 5.10;
	var settingSelected = jQuery("#setting").val();

	if (jQuery('#table_from').val() == '') {
		var value = parseFloat(jQuery('#table_left_hidden').val()).toFixed(2);
		jQuery('#table_from').val(parseFloat(value).toFixed(2)+' %');
		return false;
	} else {
		var hidden_depth_value = parseFloat($('#table_left_hidden').val()).toFixed(2);
		var table_value = parseFloat(jQuery('#table_from').val()).toFixed(2);
	}

	var value = table_value;
	var table_value1_comma = value;
	value = table_value1_comma;

	var value1 = parseFloat($('#table_to').val());	

	if (isNaN(value) != false) {
		var value = parseFloat(min_table_filter).toFixed(2);
		 if(store_lang == 'de'){
          alert("Bitte geben Sie den Wert in Zahlen ein");
        }else if(store_lang == 'fr'){
           alert("Veuillez entrer la valeur en chiffres.");
        }else if(store_lang == 'it'){
           alert("Si prega di inserire il valore in numero.");
        }else{
          alert("Please enter value in number");
        }
		jQuery('#table_from').val(value + ' Tafel');
	} else if (value > value1) {
		if(store_lang == 'de'){
          alert("Falscher Tafel Angabe!");
        }else if(store_lang == 'fr'){
           alert('Plage de Conseil incorrecte !');
        }else if(store_lang == 'it'){
           alert('Gamma di Lavagna non valida!');
        }else{
         alert('Incorrect table range!');
        }
		$('#table_from').val(parseFloat(hidden_table_value).toFixed(2)+' %');
		return false;
	} else if (table_value < min_table_value) {
		if(store_lang == 'de'){
          alert("Falscher Tafel Angabe!");
        }else if(store_lang == 'fr'){
           alert('Plage de Conseil incorrecte !');
        }else if(store_lang == 'it'){
           alert('Gamma di Lavagna non valida!');
        }else{
         alert('Incorrect depth range!');
        }
		$('#table_from').val((parseFloat(min_table_value).toFixed(2))+" %");
		table_slider_render(min_table_value, value1, true);
		return false;
	} else if (settingSelected == 1 && (hidden_table_value > table_value)) {
      if(store_lang == 'de'){
        alert('Die gewählte Fassung passt zu einem Diamanten größer als ' + table_value);
      }else if(store_lang == 'fr'){
        alert('Le réglage sélectionné peut correspondre à un diamant supérieur à ' + table_value);
      }else if(store_lang == 'it'){
        alert('Limpostazione selezionata può corrispondere a un diamante maggiore di ' + table_value);
      }else{
        alert('selected setting can match with diamond greater than ' + table_value);
      }		
		jQuery('#table_from').val(hidden_table_value+" %");
		return false;
	}

	$('#table_left_hidden').val(value);
	$('#table_right_hidden').val(value1);

	table_slider_render(table_value, value1, true);
}


function replace_table_to() {
	var max_table_value = 93.00;
	var settingSelected = jQuery("#setting").val();

	if (jQuery('#table_to').val() == '') {
		var value = parseFloat(jQuery('#table_right_hidden').val()).toFixed(2);
		jQuery('#table_to').val(parseFloat(value).toFixed(2)+' %');
		return false;
	} else {
		var hidden_table_value = parseFloat(jQuery('#table_right_hidden').val()).toFixed(2);
		var table_value = parseFloat(jQuery('#table_to').val()).toFixed(2);
	}  

	value = table_value;
	var table_value1_comma = value;
	value = table_value1_comma;

	var value1 = parseFloat($('#table_from').val());	

	if (isNaN(value) != false) {
		var value = parseFloat(max_table_filter).toFixed(2);        
		if(store_lang == 'de'){
          alert("Bitte geben Sie den Wert in Zahlen ein");
        }else if(store_lang == 'fr'){
          alert("Veuillez entrer la valeur en chiffres.");
        }else if(store_lang == 'it'){
          alert("Si prega di inserire il valore in numero.");
        }{
          alert("Please enter value in number");
        }
		jQuery('#table_to').val(value + ' %');
	} else if (parseFloat(value) > parseFloat(max_table_value)) {		
		if(store_lang == 'de'){
          alert("Falscher Tafel Angabe!");
        }else if(store_lang == 'fr'){
          alert("Plage de Conseil incorrecte !");
        }else if(store_lang == 'it'){
          alert("Gamma di Lavagna non valida!");
        }else{
          alert("Incorrect table range!");
        }
		jQuery('#table_to').val(hidden_table_value+" %");
		return false;
	} else if (value1 > value) {
		if(store_lang == 'de'){
          alert("Falscher Tafel Angabe!");
        }else if(store_lang == 'fr'){
          alert("Plage de Conseil incorrecte !");
        }else if(store_lang == 'it'){
          alert("Gamma di Lavagna non valida!");
        }else{
          alert("Incorrect table range!");
        }
		$('#table_to').val(hidden_table_value+' %');
		return false;
	}else if (settingSelected == 1 && (hidden_table_value < table_value)) {
        if(store_lang == 'de'){
          alert('Die gewählte Fassung passt zu einem Diamanten mit weniger als ' + table_value);
        }else if(store_lang == 'fr'){
          alert('Le réglage sélectionné peut correspondre à un diamant inférieur à ' + table_value);
        }else if(store_lang == 'it'){
          alert('Limpostazione selezionata può corrispondere a un diamante inferiore a ' + table_value);
        }else{
          alert('Selected setting can match with diamond less than ' + table_value);
        }
		
		jQuery('#table_to').val(hidden_table_value+" %");
		return false;
	}

	$('#table_right_hidden').val(value);
	$('#table_left_hidden').val(value1);

	table_slider_render(value1, table_value, true);
}

/*** Diamond Table Filter End ***/

/************************** Start - Diamond Cut Filter **************************/
var min_cut = jQuery( "#cut-min-value" ).val();
var max_cut = jQuery( "#cut-max-value" ).val();
function cut_slider_render(start,end,option){
  
  if(store_lang == 'de'){
    var cutHeadTitle = 'Schliffgrad:';
  }else{
    var cutHeadTitle = 'Cut:';
  }

  //session cut filter selected
  var isSelected = false;
  if(start != 0 || end != 7){
     isSelected = true;
  }
  
  var selected_values = getFilterValues(min_cut,max_cut,'cut');
  
  if(selected_values[0] == selected_values[1]){
    var cutTitle = cutHeadTitle+' '+selected_values[1];
  }else{
    var cutTitle = cutHeadTitle+' '+selected_values[0]+' - '+selected_values[1];
  }
      
  
  setSelectedFilter(cutTitle,"cut_slider_render('0', '7','false')",isSelected,'cut');
  //end
  
  jQuery( "#cut_range" ).slider({ 
      range: true,
      values: [start, end],
       min: 0,
       max: 7,
       step: 1, 
       slide: function( event, ui ) {          
          if ((ui.values[0]) >= (ui.values[1])) {
            return false;
          }
             
          jQuery( "#cut-min-value" ).val(ui.values[0]);
          jQuery( "#cut-max-value" ).val(ui.values[1]);
           
      },
      change: function( event, ui ) {  
         emptyResultDiv();
        
         jQuery( "#cut-min-value" ).val(ui.values[0]);
         jQuery( "#cut-max-value" ).val(ui.values[1]);
        
         //applied filters 
         var isSelected = false;         
         if(ui.values[0] != 0 || ui.values[1] != 7){
               isSelected = true;
         }          
         var selected_values = getFilterValues(ui.values[0],ui.values[1],'cut');
          
          if(selected_values[0] == selected_values[1]){
            var cutTitle = cutHeadTitle+' '+selected_values[1];    
          }else{
            var cutTitle = cutHeadTitle+' '+selected_values[0]+' - '+selected_values[1];    
          }
          
          
          setSelectedFilter(cutTitle,"cut_slider_render('0', '7','false')",isSelected,'cut');
         //end
        
        jQuery('#page_no').val(1);
	    jQuery('#pagination').val('');
        graphqlDataCall(1);
        return false;
      }
   });
}
/************************** End - Diamond Cut Filter **************************/
/************************** Start - Diamond Polish Filter **************************/
	var min_polish = jQuery( "#polish-min-value" ).val();
	var max_polish = jQuery( "#polish-max-value" ).val();

	function polish_slider_render(start,end,option){

		if(store_lang == 'de'){
			var polishHeadTitle = 'Politur:';
		}else{
			var polishHeadTitle = 'Polish:';
		}

		//session Polish filter selected
		var isSelected = false;
		if(start != 0 || end != 6){
		   isSelected = true;
		}

		var selected_values = getFilterValues(min_polish,max_polish,'polish');

		if(selected_values[0] == selected_values[1]){
			var polishTitle = polishHeadTitle+' '+selected_values[1];
		}else{
		    var polishTitle = polishHeadTitle+' '+selected_values[0]+' - '+selected_values[1];
		}

		setSelectedFilter(polishTitle,"polish_slider_render('0', '6','false')",isSelected,'polish');
  		//end

  		jQuery( "#polish_range" ).slider({ 
	      range: true,
	      values: [start, end],
	       min: 0,
	       max: 6,
	       step: 1, 
	       slide: function( event, ui ) {          
	          if ((ui.values[0]) >= (ui.values[1])) {
	            return false;
	          }
	             
	          jQuery( "#polish-min-value" ).val(ui.values[0]);
	          jQuery( "#polish-max-value" ).val(ui.values[1]);
	           
	      },
	      change: function( event, ui ) {  
	         emptyResultDiv();
            
	         jQuery( "#polish-min-value" ).val(ui.values[0]);
	         jQuery( "#polish-max-value" ).val(ui.values[1]);
	        
	         //applied filters 
	         var isSelected = false;         
	         if(ui.values[0] != 0 || ui.values[1] != 6){
	               isSelected = true;
	         }          
	         var selected_values = getFilterValues(ui.values[0],ui.values[1],'polish');
	          
	          if(selected_values[0] == selected_values[1]){
	            var polishTitle = polishHeadTitle+' '+selected_values[1];    
	          }else{
	            var polishTitle = polishHeadTitle+' '+selected_values[0]+' - '+selected_values[1];    
	          }
	          
	          
	          setSelectedFilter(polishTitle,"polish_slider_render('0', '6','false')",isSelected,'polish');
	         //end
	        
	        jQuery('#page_no').val(1);
		    jQuery('#pagination').val('');
	        graphqlDataCall(1);
	        return false;
	      }
	   });
	}
/************************** End - Diamond Polish Filter **************************/

/************************** Start - Diamond Symmetry Filter **************************/
  var min_symmetry = jQuery( "#symmetry-min-value" ).val();
  var max_symmetry = jQuery( "#symmetry-max-value" ).val();

  function symmetry_slider_render(start,end,option){

    if(store_lang == 'de'){
      var symmetryHeadTitle = 'Symmetrie:';
    }else{
      var symmetryHeadTitle = 'Symmetry:';
    }

    //session Symmetry filter selected
    var isSelected = false;
    if(start != 0 || end != 6){
       isSelected = true;
    }

    var selected_values = getFilterValues(min_symmetry,max_symmetry,'symmetry');

    if(selected_values[0] == selected_values[1]){
      var symmetryTitle = symmetryHeadTitle+' '+selected_values[1];
    }else{
        var symmetryTitle = symmetryHeadTitle+' '+selected_values[0]+' - '+selected_values[1];
    }

    setSelectedFilter(symmetryTitle,"symmetry_slider_render('0', '6','false')",isSelected,'symmetry');
      //end

      jQuery( "#symmetry_range" ).slider({ 
        range: true,
        values: [start, end],
         min: 0,
         max: 6,
         step: 1, 
         slide: function( event, ui ) {          
            if ((ui.values[0]) >= (ui.values[1])) {
              return false;
            }
               
            jQuery( "#symmetry-min-value" ).val(ui.values[0]);
            jQuery( "#symmetry-max-value" ).val(ui.values[1]);
             
        },
        change: function( event, ui ) {  
           emptyResultDiv();
          
           jQuery( "#symmetry-min-value" ).val(ui.values[0]);
           jQuery( "#symmetry-max-value" ).val(ui.values[1]);
          
           //applied filters 
           var isSelected = false;         
           if(ui.values[0] != 0 || ui.values[1] != 6){
                 isSelected = true;
           }          
           var selected_values = getFilterValues(ui.values[0],ui.values[1],'symmetry');
            
            if(selected_values[0] == selected_values[1]){
              var symmetryTitle = symmetryHeadTitle+' '+selected_values[1];    
            }else{
              var symmetryTitle = symmetryHeadTitle+' '+selected_values[0]+' - '+selected_values[1];    
            }
            
            
            setSelectedFilter(symmetryTitle,"symmetry_slider_render('0', '6','false')",isSelected,'symmetry');
           //end
          
          jQuery('#page_no').val(1);
        jQuery('#pagination').val('');
          graphqlDataCall(1);
          return false;
        }
     });
  }
/************************** End - Diamond Symmetry Filter **************************/
/************************** Start - Diamond fluorescence Filter **************************/
  var min_fluorescence = jQuery( "#fluorescence-min-value" ).val();
  var max_fluorescence = jQuery( "#fluorescence-max-value" ).val();

  function fluorescence_slider_render(start,end,option){
  
    if(store_lang == 'de'){
      var fluorescenceHeadTitle = 'Fluoreszenz:';
    }else{
      var fluorescenceHeadTitle = 'Fluorescence:';
    }

    //session fluorescence filter selected
    var isSelected = false;
    if(start != 0 || end != 7){
       isSelected = true;
    }

    var selected_values = getFilterValues(min_fluorescence,max_fluorescence,'fluorescence');

    if(selected_values[0] == selected_values[1]){
      var fluorescenceTitle = fluorescenceHeadTitle+' '+selected_values[1];
    }else{
        var fluorescenceTitle = fluorescenceHeadTitle+' '+selected_values[0]+' - '+selected_values[1];
    }

    setSelectedFilter(fluorescenceTitle,"fluorescence_slider_render('0', '7','false')",isSelected,'fluorescence');
      //end

      jQuery( "#fluorescence_range" ).slider({ 
        range: true,
        values: [start, end],
         min: 0,
         max: 7,
         step: 1, 
         slide: function( event, ui ) {          
            if ((ui.values[0]) >= (ui.values[1])) {
              return false;
            }
               
            jQuery( "#fluorescence-min-value" ).val(ui.values[0]);
            jQuery( "#fluorescence-max-value" ).val(ui.values[1]);
             
        },
        change: function( event, ui ) {  
           emptyResultDiv();
          
           jQuery( "#fluorescence-min-value" ).val(ui.values[0]);
           jQuery( "#fluorescence-max-value" ).val(ui.values[1]);
          
           //applied filters 
           var isSelected = false;         
           if(ui.values[0] != 0 || ui.values[1] != 7){
                 isSelected = true;
           }          
           var selected_values = getFilterValues(ui.values[0],ui.values[1],'fluorescence');
            
            if(selected_values[0] == selected_values[1]){
              var fluorescenceTitle = fluorescenceHeadTitle+' '+selected_values[1];    
            }else{
              var fluorescenceTitle = fluorescenceHeadTitle+' '+selected_values[0]+' - '+selected_values[1];    
            }
            
            
          setSelectedFilter(fluorescenceTitle,"fluorescence_slider_render('0', '7','false')",isSelected,'fluorescence');
           //end
          
          jQuery('#page_no').val(1);
          jQuery('#pagination').val('');
          graphqlDataCall(1);
          return false;
        }
     });
  }
/************************** End - Diamond fluorescence Filter **************************/
/************************** Start - Diamond clarity Filter **************************/
  var min_clarity = jQuery( "#clarity-min-value" ).val();
  var max_clarity = jQuery( "#clarity-max-value" ).val();

  function clarity_slider_render(start,end,option){

    if(store_lang == 'de'){
      var clarityHeadTitle = 'Reinheit:';
    }else{
      var clarityHeadTitle = 'Clarity:';
    }

    //session clarity filter selected
    var isSelected = false;
    if(start != 0 || end != 9){
       isSelected = true;
    }

    var selected_values = getFilterValues(min_clarity,max_clarity,'clarity');

    if(selected_values[0] == selected_values[1]){
      var clarityTitle = clarityHeadTitle+' '+selected_values[1];
    }else{
        var clarityTitle = clarityHeadTitle+' '+selected_values[0]+' - '+selected_values[1];
    }

    setSelectedFilter(clarityTitle,"clarity_slider_render('0', '9','false')",isSelected,'clarity');
      //end

      jQuery( "#clarity_range" ).slider({ 
        range: true,
        values: [start, end],
         min: 0,
         max: 9,
         step: 1, 
         slide: function( event, ui ) {          
            if ((ui.values[0]) >= (ui.values[1])) {
              return false;
            }
               
            jQuery( "#clarity-min-value" ).val(ui.values[0]);
            jQuery( "#clarity-max-value" ).val(ui.values[1]);
             
        },
        change: function( event, ui ) {  
           emptyResultDiv();
          
           jQuery( "#clarity-min-value" ).val(ui.values[0]);
           jQuery( "#clarity-max-value" ).val(ui.values[1]);
          
           //applied filters 
           var isSelected = false;         
           if(ui.values[0] != 0 || ui.values[1] != 9){
                 isSelected = true;
           }          
           var selected_values = getFilterValues(ui.values[0],ui.values[1],'clarity');
            
            if(selected_values[0] == selected_values[1]){
              var clarityTitle = clarityHeadTitle+' '+selected_values[1];    
            }else{
              var clarityTitle = clarityHeadTitle+' '+selected_values[0]+' - '+selected_values[1];    
            }
            
            
          setSelectedFilter(clarityTitle,"clarity_slider_render('0', '9','false')",isSelected,'clarity');
           //end
          
          jQuery('#page_no').val(1);
        jQuery('#pagination').val('');
          graphqlDataCall(1);
          return false;
        }
     });
  }
/************************** End - Diamond clarity Filter **************************/
function gemClarity_slider_render(start,end,option){

    if(store_lang == 'de'){
      var clarityHeadTitle = 'Reinheit:';
    }else{
      var clarityHeadTitle = 'Clarity:';
    }

    //session clarity filter selected
    var isSelected = false;
    if(start != 0 || end != 5){
       isSelected = true;
    }

    var selected_values = getFilterValues(min_clarity,max_clarity,'gemClarity');   
    if(selected_values[0] == selected_values[1]){
      var clarityTitle = clarityHeadTitle+' '+selected_values[1];
    }else{
        var clarityTitle = clarityHeadTitle+' '+selected_values[0]+' - '+selected_values[1];
    }

    setSelectedFilter(clarityTitle,"gemClarity_slider_render('0', '5','false')",isSelected,'gemClarity');
      //end

      jQuery( "#gemstone_clarity_range" ).slider({ 
        range: true,
        values: [start, end],
         min: 0,
         max: 5,
         step: 1, 
         slide: function( event, ui ) {          
            if ((ui.values[0]) >= (ui.values[1])) {
              return false;
            }
               
            jQuery( "#clarity-min-value" ).val(ui.values[0]);
            jQuery( "#clarity-max-value" ).val(ui.values[1]);
             
        },
        change: function( event, ui ) {  
           emptyResultDiv();
          
           jQuery( "#clarity-min-value" ).val(ui.values[0]);
           jQuery( "#clarity-max-value" ).val(ui.values[1]);
          
           //applied filters 
           var isSelected = false;         
           if(ui.values[0] != 0 || ui.values[1] != 5){
                 isSelected = true;
           }          
           var selected_values = getFilterValues(ui.values[0],ui.values[1],'gemClarity');
            
            if(selected_values[0] == selected_values[1]){
              var clarityTitle = clarityHeadTitle+' '+selected_values[1];    
            }else{
              var clarityTitle = clarityHeadTitle+' '+selected_values[0]+' - '+selected_values[1];    
            }
            
            
          setSelectedFilter(clarityTitle,"gemClarity_slider_render('0', '5','false')",isSelected,'gemClarity');
           //end
          
          jQuery('#page_no').val(1);
        jQuery('#pagination').val('');
          graphqlDataCall(1);
          return false;
        }
     });
  }

/************************** Start - Gemstone treatment Filter **************************/
  var min_treatment = jQuery( "#treatment-min-value" ).val();
  var max_treatment = jQuery( "#treatment-max-value" ).val();

  function treatment_slider_render(start,end,option){

    if(store_lang == 'de'){
      var treatmentHeadTitle = 'Treatment:';
    }else{
      var treatmentHeadTitle = 'Treatment:';
    }

    //session treatment filter selected
    var isSelected = false;
    if(start != 0 || end != 4){
       isSelected = true;
    }

    var selected_values = getFilterValues(min_treatment,max_treatment,'treatment');

    if(selected_values[0] == selected_values[1]){
      var treatmentTitle = treatmentHeadTitle+' '+selected_values[1];
    }else{
        var treatmentTitle = treatmentHeadTitle+' '+selected_values[0]+' - '+selected_values[1];
    }

    setSelectedFilter(treatmentTitle,"treatment_slider_render('0', '4','false')",isSelected,'treatment');
      //end

      jQuery( "#gemstone_treatment_range" ).slider({ 
        range: true,
        values: [start, end],
         min: 0,
         max: 4,
         step: 1, 
         slide: function( event, ui ) {          
            if ((ui.values[0]) >= (ui.values[1])) {
              return false;
            }
               
            jQuery( "#treatment-min-value" ).val(ui.values[0]);
            jQuery( "#treatment-max-value" ).val(ui.values[1]);
             
        },
        change: function( event, ui ) {  
           emptyResultDiv();
          
           jQuery( "#treatment-min-value" ).val(ui.values[0]);
           jQuery( "#treatment-max-value" ).val(ui.values[1]);
          
           //applied filters 
           var isSelected = false;         
           if(ui.values[0] != 0 || ui.values[1] != 4){
                 isSelected = true;
           }          
           var selected_values = getFilterValues(ui.values[0],ui.values[1],'treatment');
            
            if(selected_values[0] == selected_values[1]){
              var treatmentTitle = treatmentHeadTitle+' '+selected_values[1];    
            }else{
              var treatmentTitle = treatmentHeadTitle+' '+selected_values[0]+' - '+selected_values[1];    
            }
            
            
          setSelectedFilter(treatmentTitle,"treatment_slider_render('0', '4','false')",isSelected,'treatment');
           //end
          
          jQuery('#page_no').val(1);
        jQuery('#pagination').val('');
          graphqlDataCall(1);
          return false;
        }
     });
  }
/************************** End - Gemstone treatment Filter **************************/
/************************** Start - Diamond Color Filter **************************/
  var min_color = jQuery( "#color-min-value" ).val();
  var max_color = jQuery( "#color-max-value" ).val();

  function color_slider_render(start,end,option){

    if(store_lang == 'de'){
      var colorHeadTitle = 'Farbe:';
    }else{
      var colorHeadTitle = 'Colour:';
    }

    //session color filter selected
    var isSelected = false;
    if(start != 0 || end != 8){
       isSelected = true;
    }

    var selected_values = getFilterValues(min_color,max_color,'color');

    if(selected_values[0] == selected_values[1]){
      var colorTitle = colorHeadTitle+' '+selected_values[1];
    }else{
        var colorTitle = colorHeadTitle+' '+selected_values[0]+' - '+selected_values[1];
    }

    setSelectedFilter(colorTitle,"color_slider_render('0', '8','false')",isSelected,'color');
      //end

      jQuery( "#color_range" ).slider({ 
        range: true,
        values: [start, end],
         min: 0,
         max: 8,
         step: 1, 
         slide: function( event, ui ) {          
            if ((ui.values[0]) >= (ui.values[1])) {
              return false;
            }
               
            jQuery( "#color-min-value" ).val(ui.values[0]);
            jQuery( "#color-max-value" ).val(ui.values[1]);
             
        },
        change: function( event, ui ) {  
           emptyResultDiv();
          
           jQuery( "#color-min-value" ).val(ui.values[0]);
           jQuery( "#color-max-value" ).val(ui.values[1]);
          
           //applied filters 
           var isSelected = false;         
           if(ui.values[0] != 0 || ui.values[1] != 8){
                 isSelected = true;
           }          
           var selected_values = getFilterValues(ui.values[0],ui.values[1],'color');
            
            if(selected_values[0] == selected_values[1]){
              var colorTitle = colorHeadTitle+' '+selected_values[1];    
            }else{
              var colorTitle = colorHeadTitle+' '+selected_values[0]+' - '+selected_values[1];    
            }
            
            
          setSelectedFilter(colorTitle,"color_slider_render('0', '8','false')",isSelected,'color');
           //end
          
          jQuery('#page_no').val(1);
        jQuery('#pagination').val('');
          graphqlDataCall(1);
          return false;
        }
     });
  }
/************************** End - Diamond Color Filter **************************/
/************************** Start - Diamond Intensity Filter **************************/
  var min_intensity = jQuery( "#intensity-min-value" ).val();
  var max_intensity = jQuery( "#intensity-max-value" ).val();
 

  function intensity_slider_render(start,end,option){

    if(store_lang == 'de'){
      var intensityHeadTitle = 'Intensität:';
    }else{
      var intensityHeadTitle = 'Intensity:';
    }

    //session intensity filter selected
    var isSelected = false;
    if(start != 0 || end != 12){
       isSelected = true;
    }

    var selected_values = getFilterValues(min_intensity,max_intensity,'intensity');
    if(selected_values[0] == selected_values[1]){
      var intensityTitle = intensityHeadTitle+' '+selected_values[1];
    }else{
        var intensityTitle = intensityHeadTitle+' '+selected_values[0]+' - '+selected_values[1];
    }

    setSelectedFilter(intensityTitle,"intensity_slider_render('0', '12','false')",isSelected,'intensity');
      //end

      jQuery( "#intensity_range" ).slider({ 
        range: true,
        values: [start, end],
         min: 0,
         max: 12,
         step: 1, 
         slide: function( event, ui ) {          
            if ((ui.values[0]) >= (ui.values[1])) {
              return false;
            }
               
            jQuery( "#intensity-min-value" ).val(ui.values[0]);
            jQuery( "#intensity-max-value" ).val(ui.values[1]);
             
        },
        change: function( event, ui ) {  
           emptyResultDiv();
          
           jQuery( "#intensity-min-value" ).val(ui.values[0]);
           jQuery( "#intensity-max-value" ).val(ui.values[1]);
          
           //applied filters 
           var isSelected = false;         
           if(ui.values[0] != 0 || ui.values[1] != 12){
                 isSelected = true;
           }          
           var selected_values = getFilterValues(ui.values[0],ui.values[1],'intensity');
            
            if(selected_values[0] == selected_values[1]){
              var intensityTitle = intensityHeadTitle+' '+selected_values[1];    
            }else{
              var intensityTitle = intensityHeadTitle+' '+selected_values[0]+' - '+selected_values[1];    
            }
            
            
          setSelectedFilter(intensityTitle,"intensity_slider_render('0', '12','false')",isSelected,'intensity');
           //end
          
          jQuery('#page_no').val(1);
        jQuery('#pagination').val('');
          graphqlDataCall(1);
          return false;
        }
     });
  }

  /* Gemstone  Intensity Filter */

  var min_intensity = jQuery( "#intensity-min-value" ).val();
  var max_intensity = jQuery( "#intensity-max-value" ).val();
 

  function gemIntensity_slider_render(start,end,option){

    if(store_lang == 'de'){
      var intensityHeadTitle = 'Intensität:';
    }else{
      var intensityHeadTitle = 'Intensity:';
    }

    //session intensity filter selected
    var isSelected = false;
    if(start != 0 || end != 7){
       isSelected = true;
    }

    var selected_values = getFilterValues(min_intensity,max_intensity,'gemIntensity');
    if(selected_values[0] == selected_values[1]){
      var intensityTitle = intensityHeadTitle+' '+selected_values[1];
    }else{
        var intensityTitle = intensityHeadTitle+' '+selected_values[0]+' - '+selected_values[1];
    }

    setSelectedFilter(intensityTitle,"gemIntensity_slider_render('0', '7','false')",isSelected,'gemIntensity');
      //end

      jQuery( "#gemIntensity_range" ).slider({ 
        range: true,
        values: [start, end],
         min: 0,
         max: 7,
         step: 1, 
         slide: function( event, ui ) {   
            if ((ui.values[0]) >= (ui.values[1])) {
              return false;
            }
               
            jQuery( "#intensity-min-value" ).val(ui.values[0]);
            jQuery( "#intensity-max-value" ).val(ui.values[1]);
             
        },
        change: function( event, ui ) {  
           emptyResultDiv();
          
           jQuery( "#intensity-min-value" ).val(ui.values[0]);
           jQuery( "#intensity-max-value" ).val(ui.values[1]);
          
           //applied filters 
           var isSelected = false;         
           if(ui.values[0] != 0 || ui.values[1] != 7){
                 isSelected = true;
           }          
           var selected_values = getFilterValues(ui.values[0],ui.values[1],'gemIntensity');
            if(selected_values[0] == selected_values[1]){
              var intensityTitle = intensityHeadTitle+' '+selected_values[1];    
            }else{
              var intensityTitle = intensityHeadTitle+' '+selected_values[0]+' - '+selected_values[1];    
            }
            
            
          setSelectedFilter(intensityTitle,"gemIntensity_slider_render('0', '7','false')",isSelected,'gemIntensity');
           //end
          
          jQuery('#page_no').val(1);
        jQuery('#pagination').val('');
          graphqlDataCall(1);
          return false;
        }
     });
  }
 
/************************** End - Diamond Intensity Filter **************************/

function sorting_data(sorting, className) {
     emptyResultDiv();  
  
	var sortorder = '';
	var clas = className;

	jQuery('.datagrid-sort').each(function() {
		if (jQuery(this).hasClass('fa-angle-up')) {
			jQuery(this).removeClass('fa-angle-up').addClass('fa-angle-down');
		}        
	});

	if ((mySelection[1] == sorting) && (mySelection[2] == 'asc')) {  
	sortorder = 'desc';  
     //  jQuery(clas).find('i').hide();
     jQuery(clas).find('i').addClass('fa-angle-up').removeClass('fa-angle-down');
	} else {       
		sortorder = 'asc';
      jQuery(clas).find('i').show();
		jQuery(clas).find('i').addClass('fa-angle-down').removeClass('fa-angle-up');
       
	}

    //grid view
    var sort_value = ''+sorting+'_'+sortorder;     
    var sort_text = jQuery('.'+sort_value).attr('value');
    jQuery('.sortvaluename').text(sort_text);      

  
	jQuery('#sort_call').val(sorting);
	jQuery('#sort_dir').val(sortorder);



	mySelection[1] = jQuery('#sort_call').val();
	mySelection[2] = jQuery('#sort_dir').val();  
  
	jQuery('#page_no').val(1);
	jQuery('#pagination').val('');
	graphqlDataCall(1);
}





function getFilterValues(min_value,max_value,filter) {
  var filterArray = '';
  if(filter == 'cut'){
    filterArray = cut_array;  
  }else if(filter == 'polish'){
    filterArray = polish_array;  
  }else if(filter == 'symmetry'){
    filterArray = symmetry_array;  
  }else if(filter == 'fluorescence'){
    filterArray = fluorescence_array;  
  }else if(filter == 'clarity'){
    filterArray = clarity_array;  
  }else if(filter == 'treatment'){
    filterArray = treatment_array;  
  }else if(filter == 'color'){
    filterArray = color_array;  
  }else if(filter == 'intensity'){
    filterArray = intensity_array;  
  }else if(filter == 'gemClarity'){
     filterArray = gemClarity_array;  
  }else if(filter == 'gemIntensity'){
     filterArray = intensity_array_gem;      
  }

  var i=0;
  var selected_values = [];
  $.each(filterArray, function(key,cut){     
    if(store_lang == 'de'){
       if(i == min_value){
        selected_values.push(cut);
      }
      if(i == max_value-1){
        selected_values.push(cut);
      }
    }else{
      if(i == min_value){
        selected_values.push(key);
      }
      if(i == max_value-1){
        selected_values.push(key);
      }
    }
    i++;     
  });
  
  return selected_values;
}

function getFilterUrlValues(filterValues,filter){
  var filterArray = '';
  if(filter == 'cut'){
    filterArray = cut_array_values;  
  }else if(filter == 'polish'){
    filterArray = polish_array_values;  
  }else if(filter == 'symmetry'){
    filterArray = symmetry_array_values;  
  }else if(filter == 'fluorescence'){
    filterArray = fluorescence_array_values;  
  }else if(filter == 'clarity'){
    filterArray = clarity_array_values;  
  }else if(filter == 'treatment'){
    filterArray = treatment_array_values;  
  }else if(filter == 'color'){
    filterArray = color_array_values;  
  }else if(filter == 'intensity'){
    filterArray = intensity_array_values;  
  }else if(filter == 'gemClarity'){
     filterArray = gemClarity_array_values;  
  }else if(filter == 'gemIntensity'){
     filterArray = intensity_array_values_gem;  
  }
  
  var urlFilterValues = filterValues.split(','); 

  var selected_values = [];  
  var selected_values_keys = [];

  if(filter != 'carat'){
    $.each(urlFilterValues, function(arrkey,url_cut){
      $.each(filterArray, function(key,cut){
        if(url_cut == cut){
          selected_values.push(key);
        }        
      });
    });                  
      
    if(selected_values.length != 0){
      var min_value = Math.min.apply(Math,selected_values); 
      var max_value = Math.max.apply(Math,selected_values); 
      max_value = max_value+1; 
      
      selected_values_keys.push(min_value);
      selected_values_keys.push(max_value);
    }  
  }else{
    if(urlFilterValues.length == 1){
      var min_value = urlFilterValues[0]; 
      var max_value = urlFilterValues[0]; 
    }else{
      var min_value = urlFilterValues[0]; 
      var max_value = urlFilterValues[1]; 
    }

    selected_values_keys.push(min_value);
    selected_values_keys.push(max_value);
  }
    
  return selected_values_keys;  
}

/*** Get Query Parameter Array from URL ***/
function getQueryMap(query) {
    if(typeof query !== 'string') {
       return null;
    }
    
    var toType = function(a) {
      return ({}).toString.call(a).match(/\s([a-zA-Z]+)/)[1].toLowerCase();
    }, map = {};
    
  // map the hit query into a proper object
  query.replace(/([^&|\?=]+)=?([^&]*)(?:&+|$)/g, function (match, key, value) {
      if (key in map) {
          // the key already exists, so we need to check if it is an array, if not, make it an array and add the new value
          if (toType(map[key]) !== 'array') {
              // it's not an array - make it an array
              map[key] = [map[key]];
          }
          // push the new value into the array
          map[key].push(value);
      } else {
          // put the value into the map
          map[key] = value;
      }
  });
  return map;
}
/*** End ***/

/*** Mobile Gallery Functinality Start ***/ 
$(document).on("click", ".tps_dots", function() {
  var data_thumb = jQuery(this).attr("data-thumb");  
  jQuery(".tps_dots").removeClass("active"); 
  
  jQuery(".tps_mobile_gallery_image").hide(); 
  jQuery(".tps_image_"+data_thumb).show(); 
});
/*** End ***/

/*** Product Detail Description Tabs ***/
$(document).on("click", ".tps_product_title", function(e) {
  e.stopPropagation();
  var data_section = jQuery(this).attr("data-section");  
  
  if(jQuery(this).hasClass("active")){
    jQuery(".tps_product_tabs").removeClass("active");
    jQuery(".tps_product_detail_secions").hide(); 

    jQuery(".tps_product_title").removeClass("active"); 
  }else{
      jQuery(".tps_product_tabs").removeClass("active");
      jQuery(".tps_"+data_section).addClass("active");

      jQuery(".tps_product_title").removeClass("active"); 
      jQuery(this).addClass("active");
    
      jQuery(".tps_product_detail_secions").hide(); 
      jQuery(".tps_product_"+data_section).slideDown("slow"); 
  }
  
});

document.addEventListener('DOMContentLoaded', () => {
  // Select all buttons with the class 'product__thumbnail-item'
  const thumbnailButtons = document.querySelectorAll('.product__thumbnail-item');

  // Function to update the active class based on 'aria-current'
  const updateActiveClass = () => {
    thumbnailButtons.forEach(button => {
      if (button.getAttribute('aria-current') === 'true') {
        button.classList.add('active');
      } else {
        button.classList.remove('active');
      }
    });
  };

  // Monitor changes to the 'aria-current' attribute
  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'aria-current') {
        updateActiveClass();
      }
    });
  });

  // Attach observer to each button
  thumbnailButtons.forEach(button => {
    observer.observe(button, { attributes: true });
  });

  // Initial update to handle any pre-existing 'aria-current' values
  updateActiveClass();
});

document.addEventListener("DOMContentLoaded", function () {
    const localizationForm = document.getElementById("header-localization-form");

    if (localizationForm) {
        const returnToInput = localizationForm.querySelector('input[name="return_to"]');

        if (returnToInput) {
            const currentUrl = new URL(window.location.href);
            returnToInput.value = currentUrl.pathname + currentUrl.search;
        }
    }
});

jQuery(document).ready(function () {
    jQuery("#price_from").on("focus", function () {
        // Store the original value before clearing
        jQuery(this).data("original-value", jQuery(this).val());
        jQuery(this).val(""); // Clear the input
    });

    jQuery("#price_from").on("blur", function () {
        // Restore the value if left empty
        if (jQuery(this).val().trim() === "") {
            jQuery(this).val(jQuery(this).data("original-value"));
        }
    });
    jQuery("#price_to").on("focus", function () {
        // Store the original value before clearing
        jQuery(this).data("original-value", jQuery(this).val());
        jQuery(this).val(""); // Clear the input
    });

    jQuery("#price_to").on("blur", function () {
        // Restore the value if left empty
        if (jQuery(this).val().trim() === "") {
            jQuery(this).val(jQuery(this).data("original-value"));
        }
    });

    jQuery("#price_from").on("keypress", function (e) {
        if (e.which == 13) { // Enter key
            e.preventDefault();
            replace_price_from();
            jQuery(this).blur(); // Trigger blur to reformat
        }
    });
    
    jQuery("#price_to").on("keypress", function (e) {
        if (e.which == 13) { // Enter key
            e.preventDefault();
            replace_price_to();
            jQuery(this).blur(); // Trigger blur to reformat
        }
    });


});

jQuery(document).ready(function () {
  jQuery(".header__linklist li").on("click", function () {  
    localStorage.clear(); 
  });
});

